/* ── GLOBAL CONFIG ─────────────────────────────────────────────────────────────
   Netlify serverless proxy  -  keeps Anthropic API key off the client.
────────────────────────────────────────────────────────────────────────────── */
var SCAN_PROXY_URL = 'https://lively-valkyrie-6e6aba.netlify.app/.netlify/functions/analyze-hair';

/* ── FACE DETECTION (face-api.js loaded via CDN in the liquid) ─────────────── */
var FACE_MODEL_URL = 'https://cdn.jsdelivr.net/gh/justadudewhohacks/face-api.js@0.22.2/weights';
var faceModelsLoaded = false;
var faceModelsLoadPromise = null;

function loadFaceModels() {
  if (faceModelsLoaded) return Promise.resolve();
  if (faceModelsLoadPromise) return faceModelsLoadPromise;
  if (typeof faceapi === 'undefined') return Promise.resolve();
  faceModelsLoadPromise = faceapi.nets.tinyFaceDetector.loadFromUri(FACE_MODEL_URL).then(function() {
    faceModelsLoaded = true;
  }).catch(function() { faceModelsLoadPromise = null; });
  return faceModelsLoadPromise;
}
// Start loading immediately so it's ready when user uploads
if (typeof faceapi !== 'undefined') loadFaceModels();

/* ============================================================
   PAGE ROUTER
   Works in all environments  -  iframes, Cowork preview, real browser.
   Overrides CSS :target by directly controlling display.
   ============================================================ */
(function() {
  var allPages = Array.prototype.slice.call(document.querySelectorAll('.demo-page'));

  function getStickyHeaderHeight() {
    // Scan ALL elements for sticky/fixed ones pinned to top of viewport
    var maxBottom = 0;
    var all = document.querySelectorAll('body *');
    for (var i = 0; i < all.length; i++) {
      var s = window.getComputedStyle(all[i]);
      if (s.position === 'sticky' || s.position === 'fixed') {
        var rect = all[i].getBoundingClientRect();
        // Only count elements sitting at/near the top of the viewport
        if (rect.top >= 0 && rect.top < 10 && rect.height > 0 && rect.bottom > maxBottom) {
          maxBottom = rect.bottom;
        }
      }
    }
    return maxBottom;
  }

  function showPage(hash) {
    var targetId = (hash || '').replace('#', '') || 'page-0';
    var found = false;
    var targetEl = null;
    allPages.forEach(function(page) {
      var show = (page.id === targetId);
      page.style.display = show ? 'block' : 'none';
      if (show) { found = true; targetEl = page; }
    });
    // Fallback to page-0 if hash doesn't match any page
    if (!found) {
      allPages.forEach(function(page) {
        var show = (page.id === 'page-0');
        page.style.display = show ? 'block' : 'none';
        if (show) targetEl = page;
      });
    }
    // Defer scroll one frame so layout is fully computed after display change
    var el = targetEl;
    requestAnimationFrame(function() {
      if (!el) { window.scrollTo(0, 0); return; }
      var headerH = getStickyHeaderHeight();
      var top = el.getBoundingClientRect().top + window.pageYOffset - headerH;
      window.scrollTo({ top: Math.max(0, top), behavior: 'instant' });
    });
  }

  showPage(window.location.hash);
  window.addEventListener('hashchange', function() { showPage(window.location.hash); });

  // GA4: fire quiz_start when user clicks a method card (Scan or Browse)
  document.querySelectorAll('.cc-method__option').forEach(function(el) {
    el.addEventListener('click', function() {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: 'quiz_start', quiz_name: 'Care Compass' });
    });
  });
})();


/* ============================================================
   SECONDARY TYPE SELECTION
   Primary type card click reveals an inline secondary section
   on the same page. No separate #page-2-5 step.
   ============================================================ */
(function() {

  var quizState = window.quizState = { primaryType: null, fromScan: false, porosity: null, struggle: null, colorTreatment: null };

  var hairTypeInfo = {
    '1a': { title: 'Pin Straight',     desc: 'Perfectly smooth from root to tip. No wave, no bend.' },
    '1b': { title: 'Slight Bend',      desc: 'Mostly straight with a natural bend or flip at the ends.' },
    '1c': { title: 'Natural Body',     desc: 'Straight roots with real volume and body throughout.' },
    '2a': { title: 'Subtle Waves',     desc: 'Gentle S-waves that start flat at the roots and get wavier toward the ends.' },
    '2b': { title: 'Defined Waves',    desc: 'Clear S-waves from root to tip with real movement and definition.' },
    '2c': { title: 'Strong Waves',     desc: 'Bold, rich waves with a strong S-shape. Almost curly.' },
    '3a': { title: 'Loose Curls',      desc: 'Wide, springy spirals with a clear loop and natural bounce.' },
    '3b': { title: 'Defined Ringlets', desc: 'Springy, pencil-sized ringlets full of bounce and personality.' },
    '3c': { title: 'Tight Curls',      desc: 'Dense corkscrew curls with high shrinkage and rich texture.' },
    '4a': { title: 'Soft Coils',       desc: 'Tight S-coils with a clearly visible, defined pattern.' },
    '4b': { title: 'Z-Pattern Coils',  desc: 'A distinctive zigzag pattern with dramatic shrinkage.' },
    '4c': { title: 'Very Tight Coils', desc: 'The tightest, most densely packed coil pattern.' },
  };

  var cdnBase = 'https://cdn.shopify.com/s/files/1/0621/4077/6527/files/hairtype-';

  // Record primary type on click and go directly to profile step
  document.querySelectorAll('[data-select-type]').forEach(function(el) {
    el.addEventListener('click', function() {
      var type = this.getAttribute('data-select-type');
      quizState.primaryType = type;
      quizState.fromScan = false;
      window.location.hash = '#page-3-profile';
    });
  });

  // Struggle selection
  function updateProfileNextBtn() {
    var btn = document.getElementById('cc-profile-next');
    if (!btn) return;
    if (quizState.struggle && quizState.colorTreatment) {
      btn.classList.remove('cc-profile__next--disabled');
      btn.removeAttribute('aria-disabled');
    } else {
      btn.classList.add('cc-profile__next--disabled');
      btn.setAttribute('aria-disabled', 'true');
    }
  }

  document.querySelectorAll('[data-select-struggle]').forEach(function(el) {
    el.addEventListener('click', function() {
      quizState.struggle = this.getAttribute('data-select-struggle');
      document.querySelectorAll('[data-select-struggle]').forEach(function(b) { b.classList.remove('is-selected'); });
      this.classList.add('is-selected');
      updateProfileNextBtn();
    });
  });

  document.querySelectorAll('[data-select-color]').forEach(function(el) {
    el.addEventListener('click', function() {
      quizState.colorTreatment = this.getAttribute('data-select-color');
      document.querySelectorAll('[data-select-color]').forEach(function(b) { b.classList.remove('is-selected'); });
      this.classList.add('is-selected');
      updateProfileNextBtn();
    });
  });

  // Tooltip info icons (hover + tap)
  document.querySelectorAll('.cc-struggle__info').forEach(function(icon) {
    function showTip() {
      document.querySelectorAll('.cc-struggle__info.is-open').forEach(function(o) { if (o !== icon) o.classList.remove('is-open'); });
      icon.classList.toggle('is-open');
    }
    icon.addEventListener('mouseenter', function() { icon.classList.add('is-open'); });
    icon.addEventListener('mouseleave', function() { icon.classList.remove('is-open'); });
    icon.addEventListener('click', function(e) { e.stopPropagation(); showTip(); });
  });
  document.addEventListener('click', function() {
    document.querySelectorAll('.cc-struggle__info.is-open').forEach(function(o) { o.classList.remove('is-open'); });
  });

  // Next button — prevent navigation if disabled
  var profileNextBtn = document.getElementById('cc-profile-next');
  if (profileNextBtn) {
    profileNextBtn.addEventListener('click', function(e) {
      if (this.classList.contains('cc-profile__next--disabled')) {
        e.preventDefault();
      }
    });
  }

  // Record porosity on click
  document.querySelectorAll('[data-select-porosity]').forEach(function(el) {
    el.addEventListener('click', function() {
      quizState.porosity = this.getAttribute('data-select-porosity');
    });
  });

  // Record secondary type on card click (empty string = no secondary type)
  document.addEventListener('click', function(e) {
    var el = e.target.closest('[data-select-secondary]');
    if (el) {
      var val = el.getAttribute('data-select-secondary');
      quizState.secondaryType = val || null;
    }
  });

  // When result page is shown, update it
  window.addEventListener('hashchange', function() {
    if (window.location.hash === '#page-4') updateResultPage();
  });

  // \u2500\u2500\u2500 RESULT PAGE DATA (all 12 types) \u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500
  var resultData = {
    '1a': {
      badge: 'Type 1a \u00B7 Straight',
      titleHtml: 'Sleek &amp;<br>Effortless',
      desc: 'Your hair is naturally smooth, shiny, and low-maintenance  -  the right routine keeps it that way. Type 1a is perfectly straight from root to tip, with a natural shine most people work hard to achieve. Because it\'s so smooth, scalp oils travel straight down the shaft, which can make it look oily faster than other types. A clean, balanced routine keeps your scalp fresh without stripping.',
      honestNote: null,
      routineTitle: 'The 1a Straight Routine',
      steps: [
        { product: 'Strength Revival Shampoo', freq: '2\u20133\u00D7 per week', body: 'Focus on the scalp, not the lengths  -  over-washing the ends causes breakage. Sulfate-free cleansing that removes buildup without stripping your scalp\'s natural balance.', tip: 'Let the lather rinse naturally through the lengths as you wash it out.' },
        { product: 'Strength Velvet Conditioner', freq: 'Every wash', body: 'Apply from mid-shaft to ends, leave 2\u20133 minutes, then rinse with cool water for extra shine. Silicone-free hydration that adds softness without weighing down straight strands.', tip: 'Skip the roots entirely  -  conditioner at the scalp leads to flat, oily hair.' },
        { product: 'Strength Form Gel', freq: 'Optional', body: 'Apply a small amount to damp hair for sleek styles. Smooth downward  -  never scrunch on straight hair. Best for smooth buns, slicked-back looks, and taming flyaways.', tip: 'A tiny amount goes a long way. Think edges and flyaways, not full coverage.' },
      ],
      productsLabel: 'Your matched products',
      productsTitle: 'Built for your hair',
      products: [
        { tag: 'Step 01', name: 'Strength Revival Shampoo', desc: 'Sulfate-free cleansing that removes buildup without stripping your scalp\'s natural balance. Great for keeping straight hair feeling clean and fresh.', fit: '\u2726 Great fit', fitClass: 'great' },
        { tag: 'Step 02', name: 'Strength Velvet Conditioner', desc: 'Silicone-free hydration that adds softness and shine without weighing down straight strands. Apply from mid-lengths to ends, skip the roots.', fit: '\u2726 Great fit', fitClass: 'great' },
        { tag: 'Step 03', name: 'Strength Form Gel', desc: 'Best for sleek, polished styles  -  smooth buns, slicked-back looks, and taming flyaways. Won\'t create wave on straight hair.', fit: '\u25CE Works with caveats', fitClass: 'caveat' },
      ],
      tipsLabel: 'Tips for Type 1a',
      tipsTitle: 'Make the most of straight hair',
      tips: [
        { bold: 'Conditioner goes on mid-lengths to ends only.', body: 'Straight hair distributes scalp oils quickly  -  applying conditioner at the roots makes it go limp and oily. Start below the ears and work down.' },
        { bold: 'Gel is your sleek-style secret.', body: '1a hair won\'t hold a wave, but a small amount of gel gives you smooth buns, slicked-back styles, and perfectly tamed edges.' },
        { bold: 'Wash frequency matters.', body: 'Because oils travel so easily down straight strands, you may need to shampoo more often than other types  -  2\u20133 times per week is typical.' },
        { bold: 'Fine strands: use less of everything.', body: 'Fine 1a hair gets weighed down very easily. Use a dime-sized amount of conditioner and go light on gel. Thick strands: you can be more generous and may benefit from gel on the full length for polished styles.' },
      ],
    },
    '1b': {
      badge: 'Type 1b \u00B7 Straight',
      titleHtml: 'Smooth With<br>Natural Movement',
      desc: 'Your hair is mostly straight but has a subtle personality all its own. Type 1b sits right between pin-straight and wavy  -  smooth at the roots with a natural bend or flip that shows up toward the ends, especially as hair gets longer. That gentle movement gives your hair life without committing to a full wave. Lightweight, clean products keep it looking polished and healthy.',
      honestNote: null,
      routineTitle: 'The 1b Straight Routine',
      steps: [
        { product: 'Strength Revival Shampoo', freq: '2\u20133\u00D7 per week', body: 'Massage into scalp, then rinse  -  let the lather run through the lengths as it washes out. Keeps your scalp balanced without stripping the natural oils that give 1b hair its subtle texture.', tip: 'Focus on the scalp only. Your lengths don\'t need direct shampooing.' },
        { product: 'Strength Velvet Conditioner', freq: 'Every wash', body: 'Apply mid-lengths to ends, leave 2\u20133 minutes, cool water rinse for shine. Silicone-free hydration that adds softness without buildup  -  right where your hair needs it most.', tip: 'Cool water rinse at the end seals the cuticle and adds shine.' },
        { product: 'Strength Form Gel', freq: 'Optional', body: 'Works well for sleek, smooth styles. Note: gel won\'t reliably enhance or hold that natural bend into a wave  -  1b hair tends to be resistant to holding texture.', tip: 'Use for smooth buns, edges, and flyaways. Avoid scrunching.' },
      ],
      productsLabel: 'Your matched products',
      productsTitle: 'Built for your hair',
      products: [
        { tag: 'Step 01', name: 'Strength Revival Shampoo', desc: 'Keeps your scalp balanced and clean without stripping the natural oils that give 1b hair its subtle texture.', fit: '\u2726 Great fit', fitClass: 'great' },
        { tag: 'Step 02', name: 'Strength Velvet Conditioner', desc: 'Silicone-free hydration that adds softness without buildup. Mid-lengths to ends only  -  that\'s where your hair needs it most.', fit: '\u2726 Great fit', fitClass: 'great' },
        { tag: 'Step 03', name: 'Strength Form Gel', desc: 'Works well for sleek styles. Won\'t reliably enhance the natural bend into a defined wave  -  1b tends to resist holding texture.', fit: '\u25CE Works with caveats', fitClass: 'caveat' },
      ],
      tipsLabel: 'Tips for Type 1b',
      tipsTitle: 'Make the most of your natural movement',
      tips: [
        { bold: 'Embrace the natural bend.', body: 'The subtle movement in 1b hair is best enhanced by air-drying or using a round brush while blow-drying. Fighting it only leads to frizz.' },
        { bold: 'Skip products at the roots.', body: 'Conditioner, gel, and any other styling product belongs on mid-lengths and ends  -  not at the roots where it will flatten your hair immediately.' },
        { bold: 'Gel for control, not texture.', body: 'A small amount of gel is great for smooth, polished styles and taming flyaways  -  but it won\'t reliably create or hold a wave on 1b hair.' },
        { bold: 'Fine strands: condition sparingly.', body: 'Fine 1b hair goes flat easily with too much product. Thick strands: you can use more conditioner and gel to achieve that polished, smooth look.' },
      ],
    },
    '1c': {
      badge: 'Type 1c \u00B7 Straight',
      titleHtml: 'Full, Polished &amp;<br>Naturally Voluminous',
      desc: 'You\'ve got the volume that other hair types work hard to create. Type 1c hair is straight with real body and fullness throughout  -  resistant to curling, but it holds a blowout better than almost any other hair type. Your hair has natural presence and movement that responds beautifully to smooth styling. The main challenges are frizz along the hairline and maintaining that polished look through the day.',
      honestNote: null,
      routineTitle: 'The 1c Straight Routine',
      steps: [
        { product: 'Strength Revival Shampoo', freq: '2\u20133\u00D7 per week', body: 'Focus on the scalp. Let it rinse through the lengths. Removes buildup without stripping  -  important for 1c hair, which can attract more frizz when it\'s over-dried.', tip: 'Massage the scalp well. Your hair\'s volume means you want a truly clean base.' },
        { product: 'Strength Velvet Conditioner', freq: 'Every wash', body: 'Apply mid-lengths to ends, 3 minutes, cool rinse. Your hair\'s natural body means you can condition generously without it going flat.', tip: 'Cool water rinse helps seal the cuticle and control frizz.' },
        { product: 'Strength Form Gel', freq: 'For styled looks', body: 'Works better on 1c than on 1a or 1b  -  the natural body gives the gel something to work with. Excellent for sleek styles and keeping edges smooth.', tip: 'For natural body: air-dry without product. For sleek looks: blow-dry with a round brush and smooth on a little gel.' },
      ],
      productsLabel: 'Your matched products',
      productsTitle: 'Built for your hair',
      products: [
        { tag: 'Step 01', name: 'Strength Revival Shampoo', desc: 'Removes buildup without stripping  -  important for 1c hair, which can attract more frizz when it\'s over-dried.', fit: '\u2726 Great fit', fitClass: 'great' },
        { tag: 'Step 02', name: 'Strength Velvet Conditioner', desc: 'Keeps lengths soft and smooth. Your natural body means you can condition generously without going flat.', fit: '\u2726 Great fit', fitClass: 'great' },
        { tag: 'Step 03', name: 'Strength Form Gel', desc: 'Works better on 1c than other straight types. The natural body gives gel something to hold  -  excellent for sleek styles and smooth edges.', fit: '\u2726 Great fit', fitClass: 'great' },
      ],
      tipsLabel: 'Tips for Type 1c',
      tipsTitle: 'Make the most of your volume',
      tips: [
        { bold: 'Embrace the volume  -  it\'s an asset.', body: 'Type 1c hair naturally holds a blowout better than almost any other type. A round brush and blow-dryer are your best friends for a polished, full-bodied style.' },
        { bold: 'Gel tames the hairline.', body: 'A small amount of gel smoothed over the hairline and any flyaways keeps 1c hair looking sleek even as the day goes on.' },
        { bold: 'Frizz control starts with the rinse.', body: 'Finish every wash with a cool water rinse to seal the cuticle. This single step reduces frizz significantly on 1c hair.' },
        { bold: 'Fine strands: go easy on product.', body: 'Fine 1c hair can go flat with too much conditioner  -  a small amount on ends only. Thick strands: you can be generous with both conditioner and gel and your hair can handle it.' },
      ],
    },
    '2a': {
      badge: 'Type 2a \u00B7 Wavy',
      titleHtml: 'Your Effortless<br>Beach Wave',
      desc: 'Those waves are real  -  and with the right routine, they can show up every single day. Type 2a is pure, easy texture: soft S-waves that are flat at the roots and wavier at the ends. On a good day, your hair looks like you spent the morning at the beach without trying. The challenge is getting the waves to show up consistently  -  2a waves tend to dry flat or frizzy without a little help.',
      honestNote: null,
      routineTitle: 'The 2a Wavy Routine',
      steps: [
        { product: 'Strength Revival Shampoo', freq: '1\u20132\u00D7 per week', body: 'Concentrate on the scalp, let it rinse gently through the lengths. Sulfate-free cleansing that doesn\'t strip the natural oils your waves need to form and hold.', tip: 'Less frequent washing = better wave definition. Try every 3\u20134 days.' },
        { product: 'Strength Velvet Conditioner', freq: 'Every wash', body: 'Apply, detangle gently with fingers, leave 3\u20135 minutes. Rinse, then squeeze out excess water  -  never rub. Contains hydrolyzed quinoa protein. Silicone-free hydration that keeps waves soft and defined.', tip: 'Squeeze, don\'t rub. Rubbing the towel on wavy hair creates frizz.' },
        { product: 'Strength Form Gel', freq: 'Every wash', body: 'Apply immediately to dripping-wet hair. Work in sections, scrunch upward toward the roots. Let air-dry completely  -  the less you touch it while drying, the better.', tip: 'Soaking wet is the key. If hair is only damp when you apply gel, the waves will be uneven.' },
      ],
      productsLabel: 'Your matched products',
      productsTitle: 'Built for your waves',
      products: [
        { tag: 'Step 01', name: 'Strength Revival Shampoo', desc: 'Sulfate-free cleansing that doesn\'t strip the natural oils your waves need to form and hold. Wash 1\u20132\u00D7 per week for most 2a types.', fit: '\u2726 Great fit', fitClass: 'great' },
        { tag: 'Step 02', name: 'Strength Velvet Conditioner', desc: 'Silicone-free hydration that keeps waves soft and defined without leaving a coating that weighs them down.', fit: '\u2726 Great fit', fitClass: 'great' },
        { tag: 'Step 03', name: 'Strength Form Gel', desc: 'Apply to soaking-wet hair in sections and scrunch upward  -  don\'t smooth it in. Let air-dry completely before touching.', fit: '\u2726 Great fit', fitClass: 'great' },
      ],
      tipsLabel: 'Tips for Type 2a',
      tipsTitle: 'Make the most of your waves',
      tips: [
        { bold: 'Apply gel to soaking-wet hair.', body: 'The wetter the better. This single habit is the biggest thing that will improve your wave definition. Dry or damp hair gives uneven, frizzy results.' },
        { bold: 'Scrunch upward, don\'t smooth down.', body: 'Work the gel from ends toward roots using a firm scrunching motion. Smoothing down flattens the wave  -  scrunching up encourages it to form.' },
        { bold: 'Hands off while drying.', body: 'Let your hair dry undisturbed  -  air-dry or diffuse on low heat. Touching it mid-dry breaks the wave. Wait until completely dry, then scrunch gently to release the cast.' },
        { bold: 'Fine strands: go light on gel.', body: 'Too much will weigh down those gentle waves. Start with a small amount and build up next time. Thick strands: be thorough  -  you need good coverage to define the wave.' },
      ],
    },
    '2b': {
      badge: 'Type 2b \u00B7 Wavy',
      titleHtml: 'Beautifully<br>Defined Waves',
      desc: 'You\'re right in the Ren Raa sweet spot  -  and your waves are ready to shine. Type 2b is where wave texture really shows up with confidence: clear S-waves, real movement, natural definition from roots to ends. With the right routine you can enhance your natural wave pattern and keep things looking intentional and beautiful every wash day.',
      honestNote: null,
      routineTitle: 'The 2b Wavy Routine',
      steps: [
        { product: 'Strength Revival Shampoo', freq: '1\u20132\u00D7 per week', body: 'Scrub the scalp, let it rinse gently through the waves. The sulfate-free formula is ideal for wavy hair  -  it cleanses without stripping the moisture that keeps waves defined.', tip: 'Focus on the scalp, not the lengths. Let lather rinse through naturally.' },
        { product: 'Strength Velvet Conditioner', freq: 'Every wash', body: 'Finger-detangle while conditioner is in, leave 5 minutes, rinse with cool water. Contains hydrolyzed quinoa protein  -  silicone-free and designed for exactly your texture. Apply generously from mid-lengths to ends.', tip: 'Squeeze out excess water after rinsing  -  never rub or twist.' },
        { product: 'Strength Form Gel', freq: 'Every wash', body: 'Apply to soaking-wet hair in sections. Scrunch upward firmly. Diffuse on low heat or air-dry undisturbed until completely dry. 2b is the heart of the Ren Raa sweet spot.', tip: 'Don\'t touch while drying  -  this is what keeps frizz away.' },
      ],
      productsLabel: 'Your matched products',
      productsTitle: 'Built for your waves',
      products: [
        { tag: 'Step 01', name: 'Strength Revival Shampoo', desc: 'The sulfate-free formula is ideal for wavy hair  -  cleanses without stripping the moisture that keeps your waves defined.', fit: '\u2726 Perfect fit for 2b', fitClass: 'great' },
        { tag: 'Step 02', name: 'Strength Velvet Conditioner', desc: 'Silicone-free and designed for exactly your texture. Apply generously from mid-lengths to ends while hair is wet.', fit: '\u2726 Perfect fit for 2b', fitClass: 'great' },
        { tag: 'Step 03', name: 'Strength Form Gel', desc: '2b is the heart of the Ren Raa sweet spot. This gel enhances what\'s already there without crunch, stiffness, or frizz.', fit: '\u2726 Perfect fit for 2b', fitClass: 'great' },
      ],
      tipsLabel: 'Tips for Type 2b',
      tipsTitle: 'Make the most of your waves',
      tips: [
        { bold: 'Apply gel to soaking-wet hair.', body: 'The wetter the better. This single habit is the biggest thing that will improve your wave definition. Dry or damp hair gives uneven, frizzy results.' },
        { bold: 'Scrunch upward, don\'t smooth down.', body: 'Work the gel in from ends toward roots using a firm scrunching motion. Smoothing down flattens the wave. Scrunching up encourages it to form.' },
        { bold: 'Hands off while drying.', body: 'Let your hair dry undisturbed  -  air-dry or diffuse on low heat. Touching it mid-dry breaks the wave and causes frizz. Wait until completely dry, then scrunch gently to release the cast.' },
        { bold: 'Fine strands: start with less gel and build up.', body: 'Fine 2b waves can get weighed down. Thick strands: don\'t be shy  -  go generous and make sure it\'s evenly distributed before scrunching.' },
      ],
    },
    '2c': {
      badge: 'Type 2c \u00B7 Wavy',
      titleHtml: 'Bold Waves,<br>Big Energy',
      desc: 'Your waves have serious personality  -  let\'s bring out the very best of them. Type 2c sits right at the edge of curly: thick, defined waves with a strong S-shape that give you real volume and presence. You probably have great texture, real movement, significant frizz potential, and a lot of hair. The right products and technique can make your waves look intentional and stunning every wash day.',
      honestNote: null,
      routineTitle: 'The 2c Wavy Routine',
      steps: [
        { product: 'Strength Revival Shampoo', freq: 'Once a week', body: 'Focus on the scalp, let it rinse through. Keeps your scalp clean without stripping the moisture your thick waves need. Once a week is usually enough for 2c hair.', tip: 'More frequent washing can dry out your waves. Let your scalp guide you.' },
        { product: 'Strength Velvet Conditioner', freq: 'Every wash', body: 'Be generous  -  2c hair needs more moisture than lighter wave types. Contains hydrolyzed quinoa protein that strengthens as it conditions. Focus on the mid-lengths and ends, leave on 5 minutes, rinse with cool water and squeeze out.', tip: 'Don\'t twist or rub after rinsing. Squeeze gently downward.' },
        { product: 'Strength Form Gel', freq: 'Every wash', body: 'Apply to very wet hair in sections. Work from ends to roots, scrunching upward. You may need slightly more than lighter wave types to coat and define your strands. Diffuse or air-dry fully.', tip: 'Don\'t touch while drying. The longer you leave it, the more definition you\'ll get.' },
      ],
      productsLabel: 'Your matched products',
      productsTitle: 'Built for your waves',
      products: [
        { tag: 'Step 01', name: 'Strength Revival Shampoo', desc: 'Keeps your scalp clean without stripping the moisture your thick waves need. Wash 1\u20132\u00D7 per week.', fit: '\u2726 Great fit', fitClass: 'great' },
        { tag: 'Step 02', name: 'Strength Velvet Conditioner', desc: 'Use generously  -  2c hair needs more moisture than lighter wave types. Focus on mid-lengths and ends where dryness is most common.', fit: '\u2726 Great fit', fitClass: 'great' },
        { tag: 'Step 03', name: 'Strength Form Gel', desc: 'Apply in sections to ensure even distribution. You may need slightly more than lighter wave types to fully coat and define your strands.', fit: '\u2726 Great fit', fitClass: 'great' },
      ],
      tipsLabel: 'Tips for Type 2c',
      tipsTitle: 'Make the most of your waves',
      tips: [
        { bold: 'Apply gel in sections to soaking-wet hair.', body: 'Your hair has a lot going on  -  scrunching gel through it all at once leads to uneven distribution. Work section by section from ends to roots for even definition.' },
        { bold: 'Be generous with conditioner.', body: '2c waves are close to curly territory, which means they need more moisture. Don\'t hold back  -  focus on mid-lengths and ends and leave it on for a full 5 minutes.' },
        { bold: 'Diffuse for better definition.', body: 'Diffusing on low heat (rather than air-drying) often gives 2c hair better-defined waves with less frizz, since it sets the shape faster.' },
        { bold: 'Fine strands: moderate your gel.', body: 'Even bold 2c waves can get weighed down. Thick strands: go generous on both conditioner and gel  -  your hair needs significant product to coat every strand. Take your time.' },
      ],
    },
    '3a': {
      badge: 'Type 3a \u00B7 Curly',
      titleHtml: 'Springy, Bouncy<br>&amp; Full of Life',
      desc: 'Those curls are the real thing  -  and they deserve a routine that honors them. Type 3a curls are wide, loose spirals with incredible natural bounce and movement. Your hair has real personality, and on a great wash day it\'s stunning. The main challenges are frizz, dryness, and shrinkage  -  your curls can look significantly shorter when dry than when wet. Moisture and consistent technique are the foundation of everything.',
      honestNote: null,
      routineTitle: 'The 3a Curly Routine',
      steps: [
        { product: 'Strength Revival Shampoo', freq: 'Once a week', body: 'Focus on the scalp only  -  the lengths don\'t need direct shampooing. Sulfate-free and enriched with plant oils  -  cleanses without stripping the moisture your curls need. Many 3a types find once a week is plenty.', tip: 'Let your scalp tell you  -  some weeks you may want to wait longer.' },
        { product: 'Strength Velvet Conditioner', freq: 'Every wash', body: 'Apply generously, detangle with fingers or a wide-tooth comb while it\'s in, leave 5\u201310 minutes, rinse with cool water. Contains hydrolyzed quinoa protein  -  your curls will genuinely feel the difference.', tip: 'Detangle while conditioner is in  -  never on dry hair. Start from the ends and work up.' },
        { product: 'Strength Form Gel', freq: 'Every wash', body: 'Apply immediately to dripping-wet hair. Work in sections. Scrunch upward firmly and repeatedly. Diffuse on low or air-dry. Don\'t touch until completely dry.', tip: 'The crunchy cast is normal  -  it breaks when completely dry. Scrunch gently to release it.' },
      ],
      productsLabel: 'Your matched products',
      productsTitle: 'Built for your curls',
      products: [
        { tag: 'Step 01', name: 'Strength Revival Shampoo', desc: 'Gentle sulfate-free cleansing that doesn\'t strip the moisture your curls need. Many 3a types find once a week is plenty.', fit: '\u2726 Great fit', fitClass: 'great' },
        { tag: 'Step 02', name: 'Strength Velvet Conditioner', desc: 'Your curls will drink this up. Be generous. Detangle while it\'s in, leave 5 minutes, and rinse with cool water.', fit: '\u2726 Great fit', fitClass: 'great' },
        { tag: 'Step 03', name: 'Strength Form Gel', desc: 'Provides hold and definition without the crunch. Apply to soaking-wet hair, scrunch upward firmly, and let air-dry or diffuse on low.', fit: '\u2726 Great fit', fitClass: 'great' },
      ],
      tipsLabel: 'Tips for Type 3a',
      tipsTitle: 'Make the most of your curls',
      tips: [
        { bold: 'Moisture is everything.', body: 'Curly hair is naturally drier because oils from the scalp struggle to travel the spiral of the curl. Generous conditioner every wash day is non-negotiable.' },
        { bold: 'Scrunch firmly and repeatedly.', body: 'Don\'t be shy with the scrunching. Apply gel to wet hair and scrunch upward with real intention  -  this is what coaxes the curl pattern to form and hold.' },
        { bold: 'Let the cast fully dry.', body: 'The crunchy feel after gel dries is called the cast  -  it\'s holding your curl in shape. Don\'t touch it until your hair is completely dry, then scrunch gently with your hands to soften it.' },
        { bold: 'Fine strands: lighter touch on gel.', body: 'Fine 3a curls can look limp with too much product. Conditioner from mid-lengths to ends only. Thick strands: be generous with both  -  your curls need thorough coverage.' },
      ],
    },
    '3b': {
      badge: 'Type 3b \u00B7 Curly',
      titleHtml: 'Defined Ringlets,<br>Real Presence',
      desc: 'Your curls are tight, springy, and absolutely worth the effort. Type 3b gives you tight, springy ringlets with serious definition and real personality. Shrinkage is significant  -  your curls can lose a third or more of their length when they dry. Moisture is everything. A consistent, moisture-forward routine is the difference between frizzy and defined, flat and bouncy.',
      honestNote: null,
      routineTitle: 'The 3b Curly Routine',
      steps: [
        { product: 'Strength Revival Shampoo', freq: 'Once a week', body: 'Focus on the scalp. Skip direct application to the curl lengths. Sulfate-free with nourishing plant oils  -  some 3b types prefer co-washing (conditioner only) most weeks and shampooing less often.', tip: 'If your scalp feels fine, try co-washing (conditioner only) between shampoo days.' },
        { product: 'Strength Velvet Conditioner', freq: 'Every wash', body: 'Be generous from roots to ends. Detangle with a wide-tooth comb while it\'s in. Leave 10 minutes. Rinse with cool water. Squeeze gently  -  no rubbing. Contains hydrolyzed quinoa protein that helps strengthen between washes.', tip: 'A full 10 minutes makes a real difference. Ringlets genuinely benefit from the extra time.' },
        { product: 'Strength Form Gel', freq: 'Every wash', body: 'Apply to soaking-wet hair in sections. Rake through with fingers first, then scrunch upward. Diffuse on low or air-dry. Hands-off while drying. 3b is at the outer edge of the Ren Raa sweet spot  -  still an excellent fit.', tip: 'Rake first for even distribution, then scrunch to encourage the curl to form.' },
      ],
      productsLabel: 'Your matched products',
      productsTitle: 'Built for your curls',
      products: [
        { tag: 'Step 01', name: 'Strength Revival Shampoo', desc: 'Sulfate-free with nourishing plant oils. Once a week is usually the right frequency. Worth experimenting with co-washing (conditioner only) between shampoo days.', fit: '\u2726 Great fit', fitClass: 'great' },
        { tag: 'Step 02', name: 'Strength Velvet Conditioner', desc: 'Use generously  -  3b ringlets crave moisture. Detangle while it\'s in, leave 5\u201310 minutes, cool water rinse.', fit: '\u2726 Great fit', fitClass: 'great' },
        { tag: 'Step 03', name: 'Strength Form Gel', desc: 'Provides real hold for your ringlets without stiffness. 3b is at the outer edge of the Ren Raa sweet spot  -  still an excellent fit.', fit: '\u2726 Great fit', fitClass: 'great' },
      ],
      tipsLabel: 'Tips for Type 3b',
      tipsTitle: 'Make the most of your ringlets',
      tips: [
        { bold: 'Moisture is your foundation.', body: 'A consistent, moisture-forward routine is the difference between frizzy and defined. Never skip the conditioner or rush it  -  leave it in for a full 10 minutes.' },
        { bold: 'Rake before you scrunch.', body: 'Apply gel to wet hair and rake through with your fingers first to distribute it evenly through your ringlets, then scrunch upward section by section to encourage the curl to form.' },
        { bold: 'Shrinkage is completely normal.', body: 'Type 3b curls can lose a third or more of their length when dry. This is healthy  -  it shows your curl pattern is intact. Wet curls are always longer than dry ones.' },
        { bold: 'Fine strands: light on product at roots.', body: 'Fine ringlets collapse with too much conditioner at the roots  -  apply from mid-lengths down. Thick strands: thorough coverage at every step is what makes the difference.' },
      ],
    },
    '3c': {
      badge: 'Type 3c \u00B7 Curly',
      titleHtml: 'Rich Curls,<br>Built for Moisture',
      desc: 'Your texture is beautiful  -  here\'s our honest take on what actually works for it. Type 3c curls are tight, dense corkscrews with significant shrinkage and a lot of natural texture. Moisture is the foundation of everything for your hair type, and products that don\'t strip or coat are non-negotiable. Every wash day matters, and technique is just as important as product.',
      honestNote: null,
      routineTitle: 'The 3c Curly Routine',
      steps: [
        { product: 'Strength Revival Shampoo', freq: 'Every 1\u20132 weeks', body: 'Sulfate-free and enriched with plant oils  -  a genuine upgrade from conventional shampoos that strip moisture. Many 3c types do best shampooing every 1\u20132 weeks and co-washing (conditioner only) in between. Finger-detangle first to minimize breakage.', tip: 'Focus on the scalp only. Your curl lengths don\'t need direct shampooing.' },
        { product: 'Strength Velvet Conditioner', freq: 'Every wash', body: 'Apply generously from roots to ends. Detangle with fingers or wide-tooth comb while it\'s in. Leave 10 minutes. Rinse with cool water. Hydrolyzed quinoa protein and silicone-free hydration your curls will genuinely love.', tip: 'Focus extra conditioner on the ends  -  that\'s where 3c curls are driest.' },
        { product: 'Strength Form Gel', freq: 'Every wash', body: 'Apply to soaking-wet hair in sections. Rake, then scrunch upward firmly. Diffuse on low or air-dry. Provides a lighter hold than many curl creams  -  many 3c types love the softer finish.', tip: 'Keep hands off until completely dry. Scrunch to release the cast.' },
      ],
      productsLabel: 'Your matched products',
      productsTitle: 'Built for your curls',
      products: [
        { tag: 'Step 01', name: 'Strength Revival Shampoo', desc: 'Sulfate-free and enriched with plant oils. Many 3c types do best shampooing every 1\u20132 weeks and co-washing (conditioner only) in between.', fit: '\u2726 Great fit', fitClass: 'great' },
        { tag: 'Step 02', name: 'Strength Velvet Conditioner', desc: 'Silicone-free hydration your curls will genuinely love. Be generous. Focus on the ends, which tend to be the driest.', fit: '\u2726 Great fit', fitClass: 'great' },
        { tag: 'Step 03', name: 'Strength Form Gel', desc: 'Lighter hold than many stylers made for tighter curl patterns. Works well on its own for a natural finish, or pair it with a heavier styler if you prefer more hold.', fit: '\u2726 Great fit', fitClass: 'great' },
      ],
      tipsLabel: 'Tips for Type 3c',
      tipsTitle: 'Make the most of your curls',
      tips: [
        { bold: 'Moisture above everything.', body: 'Type 3c curls benefit from long conditioning sessions. Leave conditioner in for a full 10 minutes every wash, and detangle thoroughly while it\'s in.' },
        { bold: 'Try co-washing (conditioner only) between shampoo days.', body: 'Using conditioner only (co-washing) between shampoo days helps retain moisture without stripping. Many 3c types find this makes a significant difference.' },
        { bold: 'Two approaches both work well for 3c hair.', body: 'If you love a heavier routine  -  co-washing (conditioner only) most days and using a stronger-hold gel or curl cream  -  Ren Raa fits perfectly as your shampoo step when you need a deeper, sulfate-free cleanse. If you prefer keeping things lightweight and simple, Ren Raa can be your complete routine: cleaner ingredients, less buildup, and a softer, more natural finish than most curl products. Try it and see which direction your hair responds to.' },
        { bold: 'Fine strands: moderate product.', body: 'Fine 3c hair can get weighed down. Keep gel lighter. Thick strands: be very generous with conditioner and take time distributing gel evenly  -  thick curls can clump without thorough application.' },
      ],
    },
    '4a': {
      badge: 'Type 4a \u00B7 Coily',
      titleHtml: 'Soft Coils,<br>Strong Roots',
      desc: 'Your hair is a work of art  -  and here\'s our honest take on what will help. Type 4a coils are tightly wound S-coils with incredible density and springiness. Shrinkage can be dramatic  -  your hair may appear to be half its actual length when dry. Moisture, gentle handling, and consistent care are the pillars of everything for 4a hair.',
      honestNote: 'Type 4a coils are moisture-first above everything else. Ren Raa\'s formula is free of sulfates and silicones — ingredients that actively work against coily hair. Your routine includes specific guidance on wash frequency and conditioning for your pattern.',
      routineTitle: 'The 4a Coily Routine',
      steps: [
        { product: 'Strength Revival Shampoo', freq: 'Every 2\u20134 weeks', body: 'Sulfate-free and enriched with plant oils  -  much gentler than conventional shampoos. Many 4a types prefer co-washing (conditioner only) weekly and shampooing occasionally for a deeper scalp cleanse. Always detangle before washing.', tip: 'Finger-detangle first, before getting in the shower.' },
        { product: 'Strength Velvet Conditioner', freq: 'Every wash', body: 'Apply in sections to damp hair. Detangle thoroughly. Leave 10\u201315 minutes under a shower cap. Contains hydrolyzed quinoa protein and avocado oil  -  silicone-free moisture that makes a genuine difference. Rinse with cool water.', tip: 'The shower cap step makes a real difference  -  your body heat helps the conditioner penetrate deeper.' },
        { product: 'Strength Form Gel', freq: 'For definition', body: 'Apply to wet hair in small sections. Shingling (applying product curl by curl) gives the most definition. Provides a lighter hold than most Type 4 stylers  -  some love the softer finish, others layer it over a cream.', tip: 'Air-dry or diffuse on low. The longer you leave it undisturbed, the more definition you\'ll get.' },
      ],
      productsLabel: 'Honest product assessment',
      productsTitle: 'Your honest product fit',
      products: [
        { tag: 'Step 01', name: 'Strength Revival Shampoo', desc: 'Clean, sulfate-free. Use sparingly  -  every 2\u20134 weeks for most 4a types. Co-wash in between for moisture retention.', fit: '\u2726 Great foundation', fitClass: 'great' },
        { tag: 'Step 02', name: 'Strength Velvet Conditioner', desc: 'Silicone-free moisture that genuinely works. Best left on for 10\u201315 minutes. Detangle while it\'s in. A solid foundation for any 4a routine.', fit: '\u2726 Great foundation', fitClass: 'great' },
        { tag: 'Step 03', name: 'Strength Form Gel', desc: 'Provides a lighter hold than most stylers designed for Type 4 hair. Some love the softer finish. Works well layered over a butter or cream.', fit: '\u25CE Works with caveats', fitClass: 'caveat' },
      ],
      tipsLabel: 'Tips for Type 4a',
      tipsTitle: 'Care for your coils',
      tips: [
        { bold: 'Detangle before you wash.', body: 'Always finger-detangle before getting in the shower. Wet detangling on completely tangled 4a coils causes significant breakage. Work through knots section by section while hair is dry.' },
        { bold: 'The shower cap step is worth it.', body: 'Apply conditioner generously in sections, put on a shower cap, and let your body heat work for 10\u201315 minutes. This is where the real moisture work happens.' },
        { bold: 'Shrinkage is normal and healthy.', body: 'Type 4a hair can appear to be half its actual length when dry. This is completely normal  -  it shows your coil pattern is intact. Stretched styles can show your true length.' },
        { bold: 'Fine coils need gentle handling.', body: 'Fine 4a coils are more fragile than they look  -  be very gentle with detangling. Thick coils need thorough saturation at every step  -  generous conditioner and patient product application.' },
      ],
    },
    '4b': {
      badge: 'Type 4b \u00B7 Coily',
      titleHtml: 'Bold Texture,<br>Beautiful Z-Pattern',
      desc: 'Your Z-pattern is unique  -  and deserves complete honesty from us. Type 4b hair has a dramatic zigzag pattern  -  tightly packed texture with minimal visible coil separation and significant shrinkage. It\'s incredibly versatile and beautiful, but it demands consistent moisture and the gentlest handling possible. Every product that touches your hair matters.',
      honestNote: 'Type 4b hair is one of the most moisture-hungry patterns, and every product decision matters. Ren Raa is free of sulfates and silicones. Your routine covers how to adapt each step to work with your texture.',
      routineTitle: 'The 4b Coily Routine',
      steps: [
        { product: 'Strength Revival Shampoo', freq: 'Every 2\u20134 weeks', body: 'Sulfate-free and enriched with plant oils  -  much gentler than conventional options. Co-washing (conditioner only) in between helps retain moisture. Always detangle before washing  -  never on dry hair.', tip: 'Never detangle dry 4b hair. Always work through knots with conditioner in.' },
        { product: 'Strength Velvet Conditioner', freq: 'Every wash', body: 'Apply in sections, generously. Detangle while it\'s in. Leave under a shower cap for 15\u201330 minutes if possible. Contains hydrolyzed quinoa protein and avocado oil. Cool water rinse. Works as both rinse-out and co-washing (conditioner only).', tip: 'The longer you leave it, the better. 15\u201330 minutes makes a real difference for 4b hair.' },
        { product: 'Strength Form Gel', freq: 'For definition', body: 'A lighter hold than what most 4b types use as a primary styler. Layer products for best results: leave-in conditioner, then butter or cream for moisture, then gel for hold. Work in small sections.', tip: 'Small sections at every step mean better coverage and more even results.' },
      ],
      productsLabel: 'Honest product assessment',
      productsTitle: 'Your honest product fit',
      products: [
        { tag: 'Step 01', name: 'Strength Revival Shampoo', desc: 'Sulfate-free and enriched with plant oils  -  much gentler than conventional options. Use sparingly, every 2\u20134 weeks. Co-washing (conditioner only) in between.', fit: '\u2726 Great foundation', fitClass: 'great' },
        { tag: 'Step 02', name: 'Strength Velvet Conditioner', desc: 'Contains hydrolyzed quinoa protein and avocado oil. Silicone-free. Works as both rinse-out and co-washing (conditioner only). Apply in sections, leave under a shower cap for 15\u201330 minutes.', fit: '\u2726 Great foundation', fitClass: 'great' },
        { tag: 'Step 03', name: 'Strength Form Gel', desc: 'Lighter than typical 4b stylers. Works best as a finishing layer over a leave-in or butter  -  not as a standalone styler for this pattern.', fit: '\u25CE Works with caveats', fitClass: 'caveat' },
      ],
      tipsLabel: 'Tips for Type 4b',
      tipsTitle: 'Care for your coils',
      tips: [
        { bold: 'Never detangle dry.', body: 'Always work through tangles with conditioner in  -  never on dry hair. Finger-detangle first from ends to roots, then a wide-tooth comb if needed.' },
        { bold: 'Layer your products.', body: 'Leave-in conditioner \u2192 butter or cream for moisture sealing \u2192 gel for hold. Layering in this order gives 4b hair the best definition and moisture retention.' },
        { bold: 'Work in small sections.', body: 'Small sections at every step  -  shampooing, conditioning, styling  -  mean better coverage and more even results. Don\'t rush by working in large chunks.' },
        { bold: 'Fine coils are more fragile.', body: 'Fine 4b hair needs especially gentle detangling. Lighter product layers work better than heavy stacking. Thick coils need thorough saturation at every step  -  don\'t rush wash day.' },
      ],
    },
    '4c': {
      badge: 'Type 4c \u00B7 Coily',
      titleHtml: 'Maximum Texture,<br>Maximum Potential',
      desc: 'Your hair is extraordinary  -  and you deserve complete honesty from us. Type 4c is the tightest, most densely packed of all hair types. Shrinkage can be extreme  -  your hair may appear to be a quarter of its actual length when dry. It craves moisture above everything else, and needs the gentlest, cleanest products available. Protective styling, careful detangling, and consistent moisture are the foundation of great 4c care.',
      honestNote: 'Type 4c hair thrives on gentle, consistent care. No sulfates, no silicones in anything you\'re putting on it. Your routine includes the specific adjustments that make the biggest difference for this pattern.',
      routineTitle: 'The 4c Coily Routine',
      steps: [
        { product: 'Moisture first', freq: 'Every wash day', body: 'The LOC method (Liquid \u2192 Oil \u2192 Cream) or LCO works well for most 4c types. Apply each layer while hair is still damp from the previous step for maximum absorption. Moisture is the foundation of everything.', tip: 'Experiment to find which order (LOC or LCO) your hair responds to best.' },
        { product: 'Strength Revival Shampoo', freq: 'Every 4\u20136 weeks', body: 'Sulfate-free and enriched with plant oils  -  use infrequently for 4c hair. Co-washing (conditioner only) most of the time preserves moisture. When you do shampoo, focus on the scalp only and always detangle first.', tip: 'Never shampoo on tangled hair. Always detangle with conditioner in first.' },
        { product: 'Strength Velvet Conditioner', freq: 'Every wash', body: 'Contains hydrolyzed quinoa protein and avocado oil  -  silicone-free moisture your scalp and strands will appreciate. Use generously as a rinse-out. Experiment with leaving a small amount in as a light leave-in.', tip: 'Keep ends moisturized and tucked away in protective styles when possible.' },
      ],
      productsLabel: 'Honest product assessment',
      productsTitle: 'Your honest product fit',
      products: [
        { tag: 'Step 01', name: 'Strength Revival Shampoo', desc: 'Clean, sulfate-free. Use very infrequently  -  every 4\u20136 weeks is common for 4c. Co-wash the rest of the time to preserve moisture.', fit: '\u2726 Great foundation', fitClass: 'great' },
        { tag: 'Step 02', name: 'Strength Velvet Conditioner', desc: 'Silicone-free moisture that your scalp and strands will appreciate. Use generously as a rinse-out, or experiment with leaving a small amount in as a light leave-in.', fit: '\u2726 Great foundation', fitClass: 'great' },
        { tag: 'Step 03', name: 'Strength Form Gel', desc: 'Too light to serve as a primary styler for 4c hair. Could work as a finishing layer over heavier stylers, but not as a standalone for this curl pattern.', fit: '\u2013 Limited fit for 4c', fitClass: 'limited' },
      ],
      tipsLabel: 'Tips for Type 4c',
      tipsTitle: 'Care for your coils',
      tips: [
        { bold: 'Moisture is your number one priority.', body: 'Everything starts with moisture for 4c hair. The LOC method (Liquid \u2192 Oil \u2192 Cream) locks in hydration layer by layer. Experiment to find which order your hair responds to best.' },
        { bold: 'Protective styles reduce breakage.', body: 'Braids, twists, buns, and other protective styles reduce manipulation  -  one of the main causes of breakage for 4c hair. Keep ends moisturized and tucked away when possible.' },
        { bold: 'Detangle in sections, with product in.', body: 'Always work through tangles in sections with conditioner in. Finger-detangle first from ends to roots, then use a wide-tooth comb if needed. Never detangle dry 4c hair.' },
        { bold: 'Fine strands need the gentlest handling.', body: 'Fine 4c hair is more fragile than it looks. Handle it extremely gently and opt for lighter product layers. Thick strands need generous moisture at every step  -  don\'t rush wash day.' },
      ],
    },
  };

  // \u2500\u2500\u2500 THICKNESS TIPS REMOVED \u2500\u2500\u2500

  // \u2500\u2500\u2500 BLENDED ROUTINE NOTE (when secondary type is selected) \u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500
  // ─── STRUGGLE CALLOUTS ───────────────────────────────────────────────────────────
  var struggleData = {
    'frizz':      { intro: 'Since frizz is your biggest challenge, technique matters as much as product. We\'ve flagged the steps where it makes the biggest difference.', tipBold: 'Frizz tip:', tipBody: 'Apply gel to completely soaking-wet hair and don\'t touch your hair while it dries. Every time you touch it you break the gel cast and create frizz. Let it dry fully before scrunching out the crunch.' },
    'dryness':    { intro: 'Since dryness is your biggest struggle, moisture is the foundation of your entire routine. We\'ve flagged where you have the most room to make a difference.', tipBold: 'Moisture tip:', tipBody: 'Leave your conditioner on for at least 5 minutes. Rinse with cool water — warm water opens the cuticle and lets moisture escape right after you\'ve put it in.' },
    'breakage':   { intro: 'Since breakage is your biggest concern, gentle handling matters as much as the right products. We\'ve flagged the steps where most damage happens.', tipBold: 'Breakage tip:', tipBody: 'Never rub or pile hair on your head when shampooing. Work into the scalp with gentle circular motions and let it rinse through the lengths. Friction is one of the main causes of breakage.' },
    'definition': { intro: 'Since definition is what you\'re chasing, how you apply your products matters as much as which ones you use. We\'ve flagged the critical step.', tipBold: 'Definition tip:', tipBody: 'Apply gel in sections to dripping-wet hair — not damp. The wetter your hair is when you apply, the more the gel can work with your natural pattern. Scrunch upward firmly, never smooth it in.' },
    'oily-scalp': { intro: 'Since your scalp and ends need completely different things, your routine treats them separately — and it also works on resetting the cycle causing the imbalance.', tipBold: 'Scalp tip:', tipBody: 'Shampoo your scalp only — never apply directly to the lengths. Condition your ends only — never the roots. And if you\'re washing your hair often, try stretching it with further days apart. Frequent washing strips sebum, which signals the scalp to produce more oil to compensate. Most people find that once they wash less often, their scalp stops overproducing and roots stay fresh noticeably longer.' }
  };

  // ─── COLOR TREATMENT NOTES ───────────────────────────────────────────────────────
  var colorNoteData = {
    'natural':       '',
    'color-treated': 'Since your hair is color-treated, the sulfate-free formula matters more for you than most. Sulfates are the main reason color fades fast — they strip color molecules along with oil and buildup. Using this consistently means your color stays truer between salon visits.',
    'highlighted':   'Highlighted and bleached hair is more porous than untreated hair — lightening opens the cuticle, so your hair absorbs product fast but loses moisture just as quickly. The sulfate-free shampoo protects your cuticle integrity, and the silicone-free conditioner hydrates without the buildup that porous hair traps easily.'
  };


  // \u2500\u2500\u2500 POROSITY TIPS \u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500
  var porosityTipsData = {
    low:    { bold: 'Your hair is low porosity. Products need help getting in.', body: 'Apply everything to soaking-wet hair. The water acts as a carrier that helps products penetrate a selective cuticle. When conditioning, cover with a shower cap for a few minutes so your body heat can help. If you diffuse, the warmth works in your favour.' },
    medium: { bold: 'Your hair has medium porosity. Stay consistent.', body: 'Products absorb well and moisture holds, which means your routine will give you reliable results. Avoid heavy silicone-based products that can block your naturally good absorption over time and cause buildup.' },
    high:   { bold: 'Your hair is high porosity. Sealing is everything.', body: 'Finish your conditioning step with a cool water rinse to help close the cuticle and lock moisture in. Apply your styling products while hair is still very wet and layer them generously. The wetter your hair is when you apply, the better everything penetrates and holds.' }
  };

  // The signup code further down lives in a separate block and cannot see
  // these variables directly, so they are shared through window.
  window.ccPersonalisation = { struggle: struggleData, color: colorNoteData, porosity: porosityTipsData };

  // \u2500\u2500\u2500 UPDATE RESULT PAGE \u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500
  function updateResultPage() {
    var type = quizState.primaryType;
    if (!type || !resultData[type]) return;

    var d = resultData[type];

    // Expose key result data on quizState so the gate IIFE can build rich Klaviyo event properties
    quizState.resultFull    = d;
    quizState.hairTitle     = d.badge || '';
    quizState.routineTitle  = d.routineTitle || '';
    quizState.routineSteps  = (d.steps || []).map(function(s) {
      return s.product + ' (' + s.freq + '): ' + s.body;
    });
    var productIconSvg = '<svg viewBox="0 0 40 60" fill="none" stroke="currentColor" stroke-width="1.5"><rect x="12" y="6" width="16" height="48" rx="3"/><rect x="15" y="2" width="10" height="6" rx="1"/></svg>';

    // Hero
    var img = document.getElementById('result-hero-img');
    if (img) {
      img.src = cdnBase + type + '-wide.jpg';
      img.alt = 'Hair type ' + type.toUpperCase();
    }

    // Badge, title, desc
    var badge = document.getElementById('result-badge');
    if (badge) badge.textContent = d.badge;

    var title = document.getElementById('result-title');
    if (title) title.innerHTML = d.titleHtml;

    var desc = document.getElementById('result-desc');
    if (desc) desc.textContent = d.desc;

    // Honest note (show for 3c, 4a, 4b, 4c)
    var note = document.getElementById('result-honest-note');
    if (note) {
      if (d.honestNote) {
        note.querySelector('p').textContent = d.honestNote;
        note.style.display = '';
      } else {
        note.style.display = 'none';
      }
    }

    // Porosity note
    var porosityNote = document.getElementById('result-porosity-note');
    if (porosityNote) {
      var porosityText = {
        low:    'Your hair is low porosity — it\'s selective about what it lets in. Use warm water before washing to help open the cuticle, apply products to soaking-wet hair, and don\'t skip the heat when diffusing.',
        medium: 'Your hair has medium porosity — the sweet spot. Products absorb well and moisture holds. Consistency in your routine is what gets the best results.',
        high:   'Your hair is high porosity — it absorbs quickly but loses moisture fast. Focus on sealing: finish with a cool water rinse after conditioning, layer products while hair is still very wet, and never skip conditioner.'
      }[quizState.porosity];
      if (porosityText) {
        porosityNote.querySelector('p').textContent = porosityText;
        porosityNote.style.display = '';
      } else {
        porosityNote.style.display = 'none';
      }
    }

    // Routine title
    var routineTitle = document.getElementById('result-routine-title');
    if (routineTitle) routineTitle.textContent = d.routineTitle;

    // Steps
    var stepsEl = document.getElementById('result-steps');
    if (stepsEl) {
      stepsEl.innerHTML = d.steps.map(function(s, i) {
        var num = ('0' + (i + 1)).slice(-2);
        return '<div class="cc-step">' +
          '<span class="cc-step__number">' + num + '</span>' +
          '<span class="cc-step__product">' + s.product + '</span>' +
          '<span class="cc-step__freq">' + s.freq + '</span>' +
          '<p class="cc-step__body">' + s.body + '</p>' +
          '<p class="cc-step__tip">' + s.tip + '</p>' +
          '</div>';
      }).join('');
    }

    // Products
    var productsLabel = document.getElementById('result-products-label');
    if (productsLabel) productsLabel.textContent = d.productsLabel;

    var productsTitle = document.getElementById('result-products-title');
    if (productsTitle) productsTitle.textContent = d.productsTitle;

    var productUrls = {
      'shampoo':     '/discount/FREECOMB?redirect=/products/strength-revival-shampoo',
      'conditioner': '/discount/FREECOMB?redirect=/products/strength-velvet-conditioner',
      'gel':         '/discount/FREECOMB?redirect=/products/strength-form-gel'
    };
    function getProductUrl(name) {
      var n = name.toLowerCase();
      if (n.indexOf('shampoo') !== -1)     return productUrls.shampoo;
      if (n.indexOf('conditioner') !== -1) return productUrls.conditioner;
      if (n.indexOf('gel') !== -1)         return productUrls.gel;
      return null;
    }

    var productImgs = {
      'shampoo':     'https://cdn.shopify.com/s/files/1/0621/4077/6527/files/2048x2048px_shampoo_sep25.jpg?v=1758133805',
      'conditioner': 'https://cdn.shopify.com/s/files/1/0621/4077/6527/files/2048x2048px_conditioner_sep25.jpg?v=1758133823',
      'gel':         'https://cdn.shopify.com/s/files/1/0621/4077/6527/files/2048x2048px_gel_sep25.jpg?v=1758133836'
    };
    function getProductImg(name) {
      var n = (name || '').toLowerCase();
      if (n.indexOf('shampoo') !== -1)     return productImgs.shampoo;
      if (n.indexOf('conditioner') !== -1) return productImgs.conditioner;
      if (n.indexOf('gel') !== -1)         return productImgs.gel;
      return null;
    }

    var productsEl = document.getElementById('result-products');
    if (productsEl) {
      productsEl.innerHTML = d.products.map(function(p) {
        var fitCls = p.fitClass === 'great' ? '' : (p.fitClass === 'caveat' ? ' cc-product-card__fit--caveat' : ' cc-product-card__fit--limited');
        var imgUrl = getProductImg(p.name);
        var imgHtml = imgUrl
          ? '<img src="' + imgUrl + '" alt="' + p.name + '" loading="lazy">'
          : '<div class="cc-product-card__image-placeholder">' + productIconSvg + '</div>';
        var cardUrl = getProductUrl(p.name);
        var cardTag = cardUrl ? 'a' : 'div';
        var cardAttr = cardUrl ? ' href="' + cardUrl + '" target="_blank" rel="noopener"' : '';
        return '<' + cardTag + ' class="cc-product-card"' + cardAttr + '>' +
          '<div class="cc-product-card__image">' + imgHtml + '</div>' +
          '<div class="cc-product-card__body">' +
            '<span class="cc-product-card__tag">' + p.tag + '</span>' +
            '<span class="cc-product-card__name">' + p.name + '</span>' +
            '<p class="cc-product-card__desc">' + p.desc + '</p>' +
            '<span class="cc-product-card__fit' + fitCls + '">' + p.fit + '</span>' +
          '</div>' +
          '</' + cardTag + '>';
      }).join('');
    }

    // Tips (first 3 technique tips + 1 personalised thickness tip)
    var tipsLabel = document.getElementById('result-tips-label');
    if (tipsLabel) tipsLabel.textContent = d.tipsLabel;

    var tipsTitle = document.getElementById('result-tips-title');
    if (tipsTitle) tipsTitle.textContent = d.tipsTitle;

    var tipsList = document.getElementById('result-tips-list');
    if (tipsList) {
      var allTips = d.tips.slice(0, 3);
      // Add struggle tip if available
      if (quizState.struggle && struggleData[quizState.struggle]) {
        var sd = struggleData[quizState.struggle];
        allTips = allTips.concat([{ bold: sd.tipBold, body: sd.tipBody, struggle: true }]);
      }
      // Add porosity tip if available
      if (quizState.porosity && porosityTipsData[quizState.porosity]) {
        var pt = porosityTipsData[quizState.porosity];
        allTips = allTips.concat([{ bold: pt.bold, body: pt.body, porosity: true }]);
      }

      tipsList.innerHTML = allTips.map(function(t) {
        var cls = 'cc-tips__item' + (t.struggle ? ' cc-tips__item--struggle' : '') + (t.porosity ? ' cc-tips__item--porosity' : '');
        return '<li class="' + cls + '">' +
          '<div class="cc-tips__bullet"></div>' +
          '<p class="cc-tips__body"><strong>' + t.bold + '</strong> ' + t.body + '</p>' +
          '</li>';
      }).join('');
    }

    // Struggle callout note
    var struggleNoteEl = document.getElementById('result-struggle-note');
    if (struggleNoteEl) {
      if (quizState.struggle && struggleData[quizState.struggle]) {
        struggleNoteEl.querySelector('p').textContent = struggleData[quizState.struggle].intro;
        struggleNoteEl.style.display = '';
      } else {
        struggleNoteEl.style.display = 'none';
      }
    }

    // Color treatment note — inject into products section
    var productsEl2 = document.getElementById('result-products');
    var colorNote = document.getElementById('result-color-note');
    if (!colorNote && productsEl2 && quizState.colorTreatment && colorNoteData[quizState.colorTreatment]) {
      var cn = document.createElement('p');
      cn.id = 'result-color-note';
      cn.className = 'cc-result__color-note';
      cn.textContent = colorNoteData[quizState.colorTreatment];
      productsEl2.parentNode.insertBefore(cn, productsEl2);
    } else if (colorNote) {
      colorNote.textContent = (quizState.colorTreatment && colorNoteData[quizState.colorTreatment]) ? colorNoteData[quizState.colorTreatment] : '';
      colorNote.style.display = (quizState.colorTreatment && colorNoteData[quizState.colorTreatment]) ? '' : 'none';
    }
  }

  // Expose so the gate IIFE can call it after unlocking content
  window.updateResultPage = updateResultPage;

  // Back navigation helper: history.back() is unreliable with hash routing.
  // This function navigates to the correct page based on quiz state.
  window.ccGoBack = function(currentPage) {
    var state = window.quizState || {};
    if (currentPage === 'page-3-profile') {
      if (state.fromScan) {
        window.location.hash = '#page-scan';
        return;
      }
      var firstChar = String(state.primaryType || '')[0];
      var dest = { '1': '#page-2-straight', '2': '#page-2-wavy', '3': '#page-2-curly', '4': '#page-2-coily' }[firstChar] || '#page-1';
      window.location.hash = dest;
    } else if (currentPage === 'page-3-5') {
      window.location.hash = '#page-3-profile';
    }
  };

})();


/* ============================================================
   AI HAIR SCAN
   - Multi-photo upload (up to 3)
   - Without API key: demo simulation showing primary + secondary type
   - With API key: real Claude vision call (all photos sent together)
   ============================================================ */
(function() {

  var fileInput   = document.getElementById('scan-file-input');
  var scanZone    = document.getElementById('scan-zone');
  var photosGrid  = document.getElementById('scan-photos');
  var photoCount  = document.getElementById('scan-photo-count');
  var analyzeBtn  = document.getElementById('scan-analyze-btn');
  var apiKeyInput = document.getElementById('scan-api-key');
  // Hide developer API key input when the proxy is configured (customers don't need it)
  if (SCAN_PROXY_URL) {
    var apiDetails = document.getElementById('scan-api-details');
    if (apiDetails) apiDetails.style.display = 'none';
  }
  var uploadSec   = document.getElementById('scan-upload-section');
  var loading     = document.getElementById('scan-loading');
  var loadingText = document.getElementById('scan-loading-text');
  var loadingSub  = document.getElementById('scan-loading-sub');
  var result      = document.getElementById('scan-result');
  var errorBox    = document.getElementById('scan-error');
  var resBadge    = document.getElementById('scan-result-badge');
  var resTitle    = document.getElementById('scan-result-title');
  var resDesc     = document.getElementById('scan-result-desc');
  var resConf     = document.getElementById('scan-result-confidence');
  var resLabel    = document.getElementById('scan-result-label');
  var resSecondary      = document.getElementById('scan-result-secondary');
  var resSecondaryBadge = document.getElementById('scan-result-secondary-badge');
  var resConfPct        = document.getElementById('scan-confidence-pct');
  var resConfFill       = document.getElementById('scan-confidence-fill');
  var scanUnclear       = document.getElementById('scan-unclear');
  var scanRetryBtn      = document.getElementById('scan-retry-btn');

  var MAX_PHOTOS = 3;
  var photos = []; // array of { base64, mime, dataUrl }

  var hairTypes = {
    '1a': { title: 'Pin Straight',  family: 'Straight', desc: 'Completely smooth from root to tip with no wave or bend  -  the definition of straight hair.' },
    '1b': { title: 'Slight Bend',   family: 'Straight', desc: 'Mostly straight with a subtle bend or flip at the ends, adding a touch of softness.' },
    '1c': { title: 'Subtle Body',   family: 'Straight', desc: 'Straight but with natural body and volume  -  resists curl but holds a blowout beautifully.' },
    '2a': { title: 'Subtle Waves',  family: 'Wavy',     desc: 'Gentle, barely-there waves that create a soft S-shape  -  a relaxed, effortless texture.' },
    '2b': { title: 'Defined Waves', family: 'Wavy',     desc: 'Clear S-waves from root to tip with real movement and definition  -  the most common wavy type.' },
    '2c': { title: 'Strong Waves',  family: 'Wavy',     desc: 'Rich, bold waves that almost look like loose curls  -  full of volume and personality.' },
    '3a': { title: 'Loose Curls',   family: 'Curly',    desc: 'Wide, springy loops with a big S-shape  -  lots of natural movement and bounce.' },
    '3b': { title: 'Defined Curls', family: 'Curly',    desc: 'Springy ringlets with a tighter coil than 3a  -  clearly defined and full of life.' },
    '3c': { title: 'Tight Curls',   family: 'Curly',    desc: 'Corkscrew curls  -  very dense and full with high shrinkage and lots of texture.' },
    '4a': { title: 'Soft Coils',    family: 'Coily',    desc: 'Tight but defined S-coils  -  springy and fine with a visible curl pattern.' },
    '4b': { title: 'Z-Pattern',     family: 'Coily',    desc: 'A zigzag pattern with less defined curl  -  dense, full of texture and character.' },
    '4c': { title: 'Tight Coils',   family: 'Coily',    desc: 'Very tight zigzag coils with minimal visible curl definition and maximum shrinkage.' },
  };

  // Simulation pairs  -  realistic combos of primary + secondary
  var simPairs = [
    { primary: '2a', secondary: '2b' },
    { primary: '2b', secondary: '2c' },
    { primary: '2b', secondary: '3a' },
    { primary: '2c', secondary: '3a' },
    { primary: '3a', secondary: '2c' },
    { primary: '3a', secondary: '3b' },
    { primary: '3b', secondary: '3a' },
    { primary: '3b', secondary: '3c' },
    { primary: '1b', secondary: '2a' },
    { primary: '1c', secondary: '2a' },
  ];

  /* \u2500\u2500 Render photo grid \u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500 */
  function renderPhotos() {
    photosGrid.innerHTML = '';
    photos.forEach(function(p, i) {
      var slot = document.createElement('div');
      slot.className = 'cc-scan__photo-slot';
      var img = document.createElement('img');
      img.src = p.dataUrl;
      img.alt = 'Hair photo ' + (i + 1);
      var btn = document.createElement('button');
      btn.className = 'cc-scan__photo-remove';
      btn.type = 'button';
      btn.innerHTML = '&times;';
      btn.title = 'Remove';
      btn.addEventListener('click', function(e) {
        e.stopPropagation();
        photos.splice(i, 1);
        renderPhotos();
      });
      slot.appendChild(img);
      slot.appendChild(btn);
      photosGrid.appendChild(slot);
    });

    // Add "+ Add" slot if room for more
    if (photos.length > 0 && photos.length < MAX_PHOTOS) {
      var addSlot = document.createElement('div');
      addSlot.className = 'cc-scan__photo-slot cc-scan__photo-slot--add';
      addSlot.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg><span>Add photo</span>';
      addSlot.addEventListener('click', function() { fileInput.click(); });
      photosGrid.appendChild(addSlot);
    }

    var hasPhotos = photos.length > 0;
    photosGrid.classList.toggle('has-photos', hasPhotos);
    scanZone.style.display = hasPhotos ? 'none' : '';
    photoCount.style.display = hasPhotos ? 'block' : 'none';
    photoCount.textContent = photos.length + ' photo' + (photos.length !== 1 ? 's' : '') + ' selected' + (photos.length < MAX_PHOTOS ? '  -  you can add ' + (MAX_PHOTOS - photos.length) + ' more' : ' (maximum reached)');

    if (analyzeBtn) {
      if (hasPhotos) analyzeBtn.removeAttribute('disabled');
      else analyzeBtn.setAttribute('disabled', 'disabled');
    }
  }

  /* -- Face picker -- */
  var facePicker        = document.getElementById('face-picker');
  var facePickerImg     = document.getElementById('face-picker-img');
  var facePickerOverlay = document.getElementById('face-picker-overlay');
  var facePickerSkip    = document.getElementById('face-picker-skip');
  var pendingFacePhoto  = null;
  var photoWasFaceCropped = false; // true when user picked a face from a multi-person photo

  function detectFaces(dataUrl) {
    return new Promise(function(resolve) {
      if (typeof faceapi === 'undefined') { resolve(null); return; }
      var run = function() {
        var img = new Image();
        img.onload = function() {
          faceapi.detectAllFaces(img, new faceapi.TinyFaceDetectorOptions({ scoreThreshold: 0.38 }))
            .then(function(dets) { resolve(dets); }).catch(function() { resolve(null); });
        };
        img.onerror = function() { resolve(null); };
        img.src = dataUrl;
      };
      if (faceModelsLoaded) {
        run();
      } else {
        var p = loadFaceModels();
        if (p && p.then) { p.then(run).catch(function() { resolve(null); }); }
        else { resolve(null); }
      }
    });
  }

  function cropToFace(detection, photoObj, onDone) {
    var img = new Image();
    img.onload = function() {
      var box = detection.box;
      var padTop    = box.height * 0.8;  // above head for top of hair
      var padSide   = box.width  * 0.25; // tight sides to exclude nearby people
      var padBottom = box.height * 2.5;  // long downward stretch to capture hair length
      var x = Math.max(0, box.x - padSide);
      var y = Math.max(0, box.y - padTop);
      var w = Math.min(img.width  - x, box.width  + padSide * 2);
      var h = Math.min(img.height - y, box.height + padTop + padBottom);
      var canvas = document.createElement('canvas');
      canvas.width = w; canvas.height = h;
      canvas.getContext('2d').drawImage(img, x, y, w, h, 0, 0, w, h);
      var croppedUrl = canvas.toDataURL(photoObj.mime || 'image/jpeg', 0.92);
      onDone({ dataUrl: croppedUrl, base64: croppedUrl.split(',')[1], mime: photoObj.mime });
    };
    img.src = photoObj.dataUrl;
  }

  function showFacePicker(photoObj, detections) {
    if (!facePicker || !facePickerImg || !facePickerOverlay) {
      photos.push(photoObj); renderPhotos(); return;
    }
    pendingFacePhoto = photoObj;
    facePickerImg.src = photoObj.dataUrl;
    facePickerOverlay.innerHTML = '';

    facePickerImg.onload = function() {
      var displayW = facePickerImg.clientWidth;
      var displayH = facePickerImg.clientHeight;
      var scaleX = displayW / facePickerImg.naturalWidth;
      var scaleY = displayH / facePickerImg.naturalHeight;

      detections.forEach(function(det, idx) {
        var box = det.box;
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'cc-face-picker__face';
        btn.setAttribute('aria-label', 'Select face ' + (idx + 1));
        btn.style.left   = (box.x * scaleX) + 'px';
        btn.style.top    = (box.y * scaleY) + 'px';
        btn.style.width  = (box.width  * scaleX) + 'px';
        btn.style.height = (box.height * scaleY) + 'px';
        btn.addEventListener('click', function() {
          var capturedPhoto = pendingFacePhoto; // capture before hideFacePicker nulls it
          hideFacePicker();
          cropToFace(det, capturedPhoto, function(cropped) {
            photoWasFaceCropped = true;
            photos.push(cropped); renderPhotos();
          });
        });
        facePickerOverlay.appendChild(btn);
      });

      facePicker.classList.add('is-visible');
    };
    if (facePickerImg.complete && facePickerImg.naturalWidth) facePickerImg.onload();
  }

  function hideFacePicker() {
    if (facePicker) facePicker.classList.remove('is-visible');
    pendingFacePhoto = null;
  }

  if (facePickerSkip) {
    facePickerSkip.addEventListener('click', function() {
      if (pendingFacePhoto) { photos.push(pendingFacePhoto); renderPhotos(); }
      hideFacePicker();
    });
  }

  /* -- File input change -- */
  if (fileInput) {
    fileInput.addEventListener('change', function(e) {
      var files = Array.prototype.slice.call(e.target.files || []);
      var remaining = MAX_PHOTOS - photos.length;
      files = files.slice(0, remaining);

      var pending = files.length;
      if (pending === 0) return;

      // Compress a full-resolution dataUrl to JPEG at max 1600px on the longest side.
      // Keeps each photo under ~400 KB so the combined payload stays well within
      // Netlify's 6 MB function body limit.
      function compressPhoto(dataUrl, cb) {
        var img = new Image();
        img.onload = function() {
          var MAX_PX = 1600, QUALITY = 0.82;
          var w = img.naturalWidth, h = img.naturalHeight;
          var scale = Math.min(1, MAX_PX / Math.max(w, h));
          var canvas = document.createElement('canvas');
          canvas.width  = Math.round(w * scale);
          canvas.height = Math.round(h * scale);
          canvas.getContext('2d').drawImage(img, 0, 0, canvas.width, canvas.height);
          cb(canvas.toDataURL('image/jpeg', QUALITY));
        };
        img.src = dataUrl;
      }

      files.forEach(function(file) {
        var reader = new FileReader();
        reader.onload = function(ev) {
          compressPhoto(ev.target.result, function(dataUrl) {
            var photoObj = { dataUrl: dataUrl, base64: dataUrl.split(',')[1], mime: 'image/jpeg' };
            detectFaces(dataUrl).then(function(dets) {
              pending--;
              if (dets && dets.length > 1) {
                showFacePicker(photoObj, dets);
                if (pending === 0) renderPhotos();
              } else {
                photos.push(photoObj);
                if (pending === 0) renderPhotos();
              }
            });
          });
        };
        reader.readAsDataURL(file);
      });

      fileInput.value = ''; // reset so same file can be re-added
    });
  }

  // Clicking the initial drop zone triggers file picker
  if (scanZone) {
    scanZone.addEventListener('click', function() { if (fileInput) fileInput.click(); });
  }

  /* \u2500\u2500 Confidence word \u2192 percentage \u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500 */
  function confidencePct(word) {
    // Maps high/medium/low to a realistic percentage range
    var w = (word || '').toLowerCase();
    if (w === 'high')   return Math.floor(Math.random() * 13) + 83; // 83\u201395
    if (w === 'medium') return Math.floor(Math.random() * 18) + 62; // 62\u201379
    if (w === 'low')    return Math.floor(Math.random() * 18) + 32; // 32\u201349
    // If a number string comes in (from future prompt changes)
    var n = parseInt(w, 10);
    if (!isNaN(n)) return Math.min(99, Math.max(10, n));
    return 75;
  }

  /* \u2500\u2500 Reset scan to upload state \u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500 */
  function resetScan() {
    photos = [];
    renderPhotos();
    if (uploadSec) uploadSec.style.display = '';
    if (loading)   loading.classList.remove('is-visible');
    if (result)    result.classList.remove('is-visible');
    if (scanUnclear) scanUnclear.classList.remove('is-visible');
    if (errorBox)  errorBox.classList.remove('is-visible');
    // Clear demo-mode label styling
    var labelEl = document.getElementById('scan-result-label');
    if (labelEl) labelEl.removeAttribute('style');
    var demoNote = document.getElementById('scan-demo-note');
    if (demoNote) demoNote.remove();
  }

  /* \u2500\u2500 Error helper \u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500 */
  function showError(msg) {
    if (errorBox)  { errorBox.textContent = msg; errorBox.classList.add('is-visible'); }
    if (loading)   loading.classList.remove('is-visible');
    if (uploadSec) uploadSec.style.display = '';
  }

  /* \u2500\u2500 Unclear photo state  -  specific messages per reason \u2500\u2500 */
  var unclearMessages = {
    'multiple_people': {
      icon: '\u{1F465}',
      title: 'Only one person per photo, please',
      desc: 'We spotted more than one person in your photo. To give an accurate reading, we need a photo where only you are visible  -  it\'s impossible to know whose hair to assess otherwise.',
      tips: ['Take a selfie or ask someone to photograph just you', 'Hair should be visible from behind or above', 'Make sure no other people appear in the frame']
    },
    'hair_styled_or_covered': {
      icon: '\u{1F64F}',
      title: 'We need to see your natural hair texture',
      desc: 'Your hair appears to be in a braid, updo, bun, ponytail, or is covered  -  we can only assess hair that is hanging freely and showing its natural texture.',
      tips: ['Wash your hair and let it air-dry naturally', 'Leave it down and unstyled', 'No braids, buns, twists, ponytails, or updos', 'No hats, hoods, or scarves']
    },
    'hair_too_short': {
      icon: '\u2702\uFE0F',
      title: 'Hair may be too short to assess',
      desc: 'Hair needs enough length (roughly chin-length or longer) to show its natural wave or curl pattern. Very short hair doesn\'t reveal enough texture for a reliable result.',
      tips: null
    },
    'hair_wet_or_product': {
      icon: '\u{1F4A7}',
      title: 'Hair looks wet or heavily styled',
      desc: 'Wet hair or hair coated in product looks the same regardless of type. For an accurate reading, hair should be clean, fully dry, and product-free.',
      tips: ['Wash hair and let it fully air-dry', 'No leave-in conditioner, gel, or oils', 'Do not blow-dry  -  air-dry only']
    },
    'hair_not_visible': {
      icon: '\u{1F50D}',
      title: 'Hair not clearly visible',
      desc: 'We couldn\'t see the hair clearly enough  -  it may be too dark, blurry, very far away, or taken from an angle where the texture isn\'t visible.',
      tips: ['Use natural daylight  -  avoid flash', 'Photo from behind or above works best', 'Move closer so hair fills most of the frame', 'Keep camera steady  -  no motion blur']
    },
    'default': {
      icon: '\u26A0',
      title: 'Photos not clear enough for a result',
      desc: 'We couldn\'t get a reliable reading from these photos. For an accurate assessment, the hair needs to be clearly visible, hanging freely, and only you should be in the photo.',
      tips: ['Natural light, no filters', 'Hair hanging down freely, air-dried', 'Only you in the photo', 'No hat, hood, braid, bun, or updo']
    }
  };

  function showUnclear(reason) {
    var msg = unclearMessages[reason] || unclearMessages['default'];

    var iconEl  = document.getElementById('scan-unclear-icon');
    var titleEl = document.getElementById('scan-unclear-title');
    var descEl  = document.getElementById('scan-unclear-desc');
    var tipsEl  = document.getElementById('scan-unclear-tips');
    var retryEl = document.getElementById('scan-retry-btn');

    if (iconEl)  iconEl.textContent  = msg.icon;
    if (titleEl) titleEl.textContent = msg.title;
    if (descEl)  descEl.textContent  = msg.desc;
    if (tipsEl) {
      if (msg.tips && msg.tips.length) {
        tipsEl.innerHTML = msg.tips.map(function(t) { return '<li>' + t + '</li>'; }).join('');
        tipsEl.style.display = '';
      } else {
        tipsEl.style.display = 'none';
      }
    }
    if (retryEl) {
      // For "too short" the primary action is to go manual
      retryEl.textContent = (reason === 'hair_too_short') ? 'Upload a different photo \u2192' : 'Try different photos \u2192';
    }

    if (loading)     loading.classList.remove('is-visible');
    if (uploadSec)   uploadSec.style.display = 'none';
    if (result)      result.classList.remove('is-visible');
    if (scanUnclear) scanUnclear.classList.add('is-visible');
  }

  // Retry button resets to upload state
  if (scanRetryBtn) {
    scanRetryBtn.addEventListener('click', function() { resetScan(); });
  }

  /* \u2500\u2500 Show result with primary + optional secondary \u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500 */
  function showResult(primary, secondary, description, confidenceWord, isSimulation) {
    if (loading) loading.classList.remove('is-visible');
    if (scanUnclear) scanUnclear.classList.remove('is-visible');
    var info = hairTypes[primary];
    if (!info) { showUnclear('default'); return; }

    // Propagate to quizState so result page (#page-4) renders correctly when user continues
    if (window.quizState) {
      window.quizState.primaryType = primary;
      window.quizState.secondaryType = secondary || null;
    }

    var secInfoRange = secondary ? hairTypes[secondary] : null;
    var badgeText = (secondary && secInfoRange)
      ? 'Type ' + primary.toUpperCase() + '\u2013' + secondary.toUpperCase() + ' \u00B7 ' + info.family
      : 'Type ' + primary.toUpperCase() + ' \u00B7 ' + info.family;
    if (resBadge)  resBadge.textContent  = badgeText;
    if (resTitle)  resTitle.textContent  = info.title;
    if (resDesc)   resDesc.textContent   = description || info.desc;
    if (resLabel) {
      resLabel.textContent = '\u2726 AI Analysis Complete';
      // Clear any demo-mode inline styles
      resLabel.removeAttribute('style');
    }
    // Remove any demo note if present
    var demoNote = document.getElementById('scan-demo-note');
    if (demoNote) demoNote.remove();

    // Confidence label (Low / Medium / High)
    var confWord = (confidenceWord || '').toLowerCase();
    var confLabel = confWord === 'high' ? 'High' : confWord === 'medium' ? 'Medium' : 'Low';
    var confBarPct = confWord === 'high' ? 88 : confWord === 'medium' ? 58 : 28;
    if (resConfPct) resConfPct.textContent = confLabel;

    // Secondary type — update label and badge
    var secInfo = secondary ? hairTypes[secondary] : null;
    if (resSecondary && resSecondaryBadge && secInfo) {
      var secLabelEl = resSecondary.querySelector('.cc-scan__result-secondary-label');
      if (secLabelEl) secLabelEl.textContent = 'Closest to:';
      resSecondaryBadge.textContent = 'Type ' + primary.toUpperCase() + ' · ' + info.title;
      resSecondary.classList.add('is-visible');
    } else if (resSecondary) {
      resSecondary.classList.remove('is-visible');
    }

    if (result) result.classList.add('is-visible');

    // Paint confidence bar via gradient on the track element — bypasses fill div issues
    var confTrack = result ? result.querySelector('.cc-scan__confidence-track') : null;
    if (confTrack) {
      var fillColor = confBarPct < 45 ? '#C09A6B' : '#4A4535';
      confTrack.style.background = 'linear-gradient(to right, ' + fillColor + ' ' + confBarPct + '%, #D4D0C8 ' + confBarPct + '%)';
    }
  }

  /* \u2500\u2500 Demo example (no API key)  -  shows UI only, not a real result \u2500\u2500 */
  function showDemoExample() {
    if (loading) loading.classList.remove('is-visible');

    // Clear any previous result state
    if (resSecondary) resSecondary.classList.remove('is-visible');
    if (scanUnclear)  scanUnclear.classList.remove('is-visible');

    // Fixed example values  -  clearly NOT based on the uploaded photo
    if (resBadge) resBadge.textContent = 'Type 2b \u00B7 Wavy';
    if (resTitle) resTitle.textContent = 'Defined Waves';
    if (resDesc)  resDesc.textContent  = 'This is a sample result showing how the AI analysis output looks  -  your uploaded photo was not analysed. In the live Shopify integration, Claude AI reads your actual hair texture and gives a personalised result.';
    if (resLabel) resLabel.textContent = '\u26A0 Example only  -  not your result';

    // No confidence bar in demo mode (would be misleading)
    if (resConfPct)  resConfPct.textContent = ' - ';
    if (resConfFill) { resConfFill.style.width = '0%'; resConfFill.classList.remove('cc-scan__confidence-fill--low'); }

    // Style the label differently so it's obvious
    var labelEl = document.getElementById('scan-result-label');
    if (labelEl) {
      labelEl.style.color    = '#C09A6B';
      labelEl.style.background = 'rgba(192,154,107,0.10)';
      labelEl.style.padding    = '4px 10px';
      labelEl.style.border     = '1px solid rgba(192,154,107,0.35)';
      labelEl.style.display    = 'inline-block';
      labelEl.style.marginBottom = '14px';
    }

    if (result) result.classList.add('is-visible');

    // Show a note below the actions explaining how to get a real result
    var existingNote = document.getElementById('scan-demo-note');
    if (!existingNote && result) {
      var note = document.createElement('p');
      note.id = 'scan-demo-note';
      note.style.cssText = 'font-size:12px;font-weight:300;color:var(--cc-muted);font-style:italic;margin-top:16px;line-height:1.6;border-top:1px solid var(--cc-border);padding-top:14px;';
      note.innerHTML = 'To analyse your real hair: expand <em>"Use your own Anthropic API key"</em> above and add your key  -  or use the live Ren Raa site once the quiz is published.';
      result.appendChild(note);
    }
  }

  /* \u2500\u2500 Analyse button \u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500 */
  if (analyzeBtn) {
    analyzeBtn.addEventListener('click', async function() {
      if (photos.length === 0) { showError('Please select at least one photo first.'); return; }
      if (errorBox) errorBox.classList.remove('is-visible');

      var apiKey = apiKeyInput ? apiKeyInput.value.trim() : '';

      /* \u2500\u2500 DEMO MODE (no API key) \u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500
         The demo cannot actually analyse your photo  -  only the live Shopify
         integration with a real API key can do that.
         We show a clearly-labelled EXAMPLE result so you can see the UI/flow.
         \u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500 */
      // If no API key AND no proxy configured → demo mode
      if (!apiKey && !SCAN_PROXY_URL) {
        if (uploadSec) uploadSec.style.display = 'none';
        if (loading)   loading.classList.add('is-visible');
        if (loadingText) loadingText.textContent = 'Preparing example result\u2026';
        if (loadingSub)  loadingSub.textContent  = 'Demo mode \u00B7 your photo is not being analysed';

        setTimeout(function() {
          showDemoExample();
        }, 1600);
        return;
      }

      /* \u2500\u2500 REAL API MODE \u2500\u2500 */
      if (uploadSec) uploadSec.style.display = 'none';
      if (loading)   loading.classList.add('is-visible');
      if (loadingText) loadingText.textContent = 'Reading your hair pattern\u2026';
      if (loadingSub)  loadingSub.textContent  = 'Analysing ' + photos.length + ' photo' + (photos.length > 1 ? 's' : '') + '\u2026';

      var prompt = [
        'You are a hair type specialist using the Andre Walker hair typing system.',
        'Analyse ' + (photos.length > 1 ? 'these ' + photos.length + ' photos' : 'this photo') + '.',
        '',
        '\u2501\u2501\u2501 STEP 1: REJECT if ANY of these conditions apply \u2501\u2501\u2501',
        '',
        'Check each condition. If ANY is true, you MUST reject  -  do not attempt to classify.',
        '',
        'REJECT with reason "multiple_people" if:',
        (photoWasFaceCropped
          ? '  NOTE: The user selected one specific face from a group photo. This image was tightly cropped around that person. A partial face or body at the very edge of the frame is acceptable \u2014 focus on and classify the hair of the MAIN person who is fully visible in the centre. Only reject if a second complete person is clearly present.'
          : '  \u2192 More than one person is visible in any photo, even partially\n  \u2192 You can see multiple faces, bodies, or sets of hair\n  Example: group photos, children together, couple photos = ALWAYS reject'),
        '',
        'REJECT with reason "hair_styled_or_covered" if:',
        '  \u2192 Hair is in a braid, plait, updo, bun, ponytail, twist, or any upswept style',
        '  \u2192 Most of the hair is clipped, pinned, or gathered up  -  REJECT even if face-framing pieces or a few tendrils hang down at the sides',
        '  \u2192 You can see only 1\u20133 strands or small sections of hair visible  -  this is NOT enough to classify accurately',
        '  \u2192 The hair that IS visible looks like just the front "face-framing" pieces rather than the person\'s full head of freely-hanging hair',
        '  CRITICAL RULE: You must be able to see the MAJORITY of the person\'s hair hanging freely to proceed. If most of their hair is hidden, clipped, or not in the frame  -  REJECT. Do not classify based on a few visible strands or front pieces alone.',
        '  \u2192 Hair is covered by a hat, hood, scarf, or headband that hides the texture',
        '  \u2192 Hair is slicked back or heavily gelled so natural texture is not visible',
        '  \u2192 Only the top or front of hair is visible, not the length and texture',
        '',
        'REJECT with reason "hair_too_short" if:',
        '  \u2192 Hair is shorter than chin-length (pixie cut, buzz cut, crew cut, very short bob)',
        '  \u2192 There is not enough length to show the natural wave or curl pattern',
        '',
        'REJECT with reason "hair_wet_or_product" if:',
        '  \u2192 Hair is visibly wet, damp, or soaking',
        '  \u2192 Hair is coated in product making it look stringy or clumped differently than its natural state',
        '',
        'REJECT with reason "hair_not_visible" if:',
        '  \u2192 No hair is visible in the photo, or the photo does not show a person at all',
        '  \u2192 Hair is too blurry, too dark, or too small to see any texture',
        '  \u2192 The camera angle hides the hair completely',
        '',
        '\u2501\u2501\u2501 STEP 2: CLASSIFY only if hair clearly passes all checks \u2501\u2501\u2501',
        '',
        'Only proceed if: exactly one person visible, hair hanging freely and air-dried, sufficient length, texture clearly visible.',
        '',
        '\u2501\u2501\u2501 MANDATORY CURL TEST \u2014 complete this BEFORE assigning any type \u2501\u2501\u2501',
        '',
        'Look at the hair in the photo and answer: Do any strands LOOP or COIL around themselves \u2014 forming ringlets, spirals, or tube-shapes that spring back when pulled?',
        '',
        '  \u2192 If YES (you can see loops, ringlets, or coils): The hair is Type 3 or Type 4. You MUST NOT assign Type 1 or Type 2. Even if the curls look "big" or "loose", looping = curly family.',
        '  \u2192 If NO (strands only bend side-to-side in a flat plane, like ocean waves): The hair is Type 1 or Type 2. No spirals, no coiling.',
        '',
        'REMEMBER: High volume, lots of movement, and defined texture do NOT make hair wavy (Type 2). Only flat S-waves = wavy. Any looping = curly.',
        '',
        'Types \u2014 read AFTER completing the curl test above:',
        '',
        '  1a \u2014 Pin-straight. Zero wave anywhere, root to tip. Hair lies flat like a sheet of silk. No bends, no movement. Example: very smooth, sleek black hair with no texture variation at all.',
        '  1b \u2014 Mostly straight. A subtle bend or flip appears only at the ends (last 5\u201310 cm). Roots and mid-lengths are completely flat and straight.',
        '  1c \u2014 Straight with body. Roots flat, no S-shape, but hair has real natural volume and fullness. May fan slightly outward at ends due to layering. Still clearly "straight" category \u2014 just not flat.',
        '  2a \u2014 ROOTS FLAT, waves from mid-length only. The roots and top sections look straight or barely textured. Soft, loose S-waves emerge only from mid-shaft to ends. Hair could pass for straight at first glance. Texture is relaxed, not defined. KEY TEST: cover the bottom half \u2014 if the top looks straight, it is 2a.',
        '  2b \u2014 FLAT S-WAVES FROM ROOT TO TIP. The hair bends side to side in one plane \u2014 like waves on the ocean \u2014 from root to tip. No loops, no coils, no ringlets. If you look at a single strand it zigzags flat, it does NOT curl around itself. Anyone looking would call this hair "wavy" not "curly". The wave pattern is clear and consistent from scalp down.',
        '  2c \u2014 Bold, rich, voluminous waves approaching curl territory. Dense S-shape throughout. High volume, strong movement. Almost looks like loose curls. Clearly distinct from 2b.',
        '  3a \u2014 Wide, springy SPIRAL LOOPS. Each strand coils around itself into a loop/tube shape. When you look at individual strands they form circles or elongated loops, not flat zigzags. About finger-width diameter. The hair clearly belongs in the CURLY family \u2014 anyone looking would call it curly, not wavy. Lots of volume and bounce. Hair frizzes easily without moisture.',
        '  3b \u2014 Tighter springy RINGLETS. Pencil-width to finger-width coils. Clearly distinct from 3a in that the ringlets are tighter and more defined. The hair forms distinct tubes/coils throughout. Dense, lots of volume. When viewed from the front, the silhouette looks full and round with defined curl clumps. CRITICAL: If you see ringlets of any kind \u2014 no matter how "big" they look \u2014 this is 3a or 3b, NOT 2b or 2c. The presence of any looping/coiling means curly family.',
        '  3c \u2014 Tight corkscrew curls. Very dense, tight spirals. High shrinkage. Clearly curly, tighter than 3b.',
        '  4a \u2014 Soft defined coils. Tight S-coil pattern, clearly defined shape visible. Coils have structure even if small.',
        '  4b \u2014 Z-pattern zigzag coils. Sharp angles rather than spirals. Dense, coarse texture. Hair grows outward/upward. Afro texture with defined zigzag rather than spiral.',
        '  4c \u2014 Very tight, dense zigzag. Minimal visible pattern definition \u2014 shrinks dramatically. Very full afro that appears uniform in texture.',
        '',
        'BOUNDARY RULES:',
        '  2a vs 2b: Look at the ROOTS. Flat roots = 2a. Waves near the root = 2b. This is the single most important distinction.',
        '  1c vs 2a: Does the hair have any actual S-wave shape? If yes (even subtle), it is 2a. If it is straight but full/voluminous, it is 1c.',
        '  2b vs 3a: MOST COMMONLY CONFUSED. Ask: does the hair form LOOPS/SPIRALS — strands that coil around themselves into ringlets that spring back when stretched? If yes: 3a or higher, NOT 2b. Or flat S-WAVES — hair that bends side to side in one plane like waves on water, never looping around itself? If yes: 2b. High volume and defined movement alone do NOT make hair 2b. Test a single strand: does it loop into a ringlet? 3a. Does it just zigzag flat? 2b.',
        '  3a vs 2c: Are there actual spirals/loops (3a) or just very strong S-waves (2c)? Loops = curly family.',
        '',
        'Give a secondary type only when the hair clearly shows characteristics of two adjacent types. Example: roots look 2a but ends are approaching 2b definition.',
        'HEAT STYLING: If the hair appears to have been blow-dried or heat-styled \u2014 look for: roots lifted with volume but no clear wave pattern at the scalp, hair that is uniformly smooth and full without a natural S-curve forming near the roots, ends with a soft outward flip or bounce rather than a true S-wave, an overall polished/groomed appearance rather than air-dried texture \u2014 then: classify one level lower than what you see (e.g. if it looks like 2b, call it 2a; if it looks like 2a, call it 1c\u20132a). Use "medium" confidence at most (never "high"). Include in the description: "Note: this hair may have been blow-dried or heat-styled, which can make wavy hair appear straighter or add volume to straight hair. For the most accurate reading, upload a photo of your natural, air-dried hair."',
        '',
        'Confidence: "high" = unambiguous match \u00B7 "medium" = probable but some ambiguity \u00B7 "low" = uncertain. Boundary cases MUST use "medium" or "low" \u2014 never "high".',
        '',
        'MULTI-PHOTO CONSISTENCY: If multiple photos are provided and they show noticeably different wave or curl levels \u2014 for example one photo looks straight and another looks wavy \u2014 this inconsistency itself lowers your confidence. In that case: classify based on the most representative photo, use "medium" or "low" confidence, and mention the inconsistency in the description (e.g. "The photos show some variation in texture, which may reflect different styling, humidity, or lighting \u2014 based on the clearest photo, the hair appears to be...").',
        '',
        '\u2501\u2501\u2501 RESPOND with JSON only  -  no markdown, no extra text \u2501\u2501\u2501',
        '',
        'If rejecting: {"primary":"unclear","secondary":null,"confidence":"low","reason":"[reason_code]","description":"One sentence explaining specifically what you see that triggered the rejection."}',
        '',
        'If classifying: {"primary":"2b","secondary":"3a","confidence":"high","reason":"ok","description":"1-2 sentences describing the specific texture and pattern you observe."}'
      ].join('\n');

      try {
        // Build content blocks  -  all photos + the prompt text
        var contentBlocks = photos.map(function(p) {
          return { type: 'image', source: { type: 'base64', media_type: p.mime, data: p.base64 } };
        });
        contentBlocks.push({ type: 'text', text: prompt });

        // Use proxy in production; fall back to direct call if developer key is set
        var fetchUrl = (SCAN_PROXY_URL && !apiKey) ? SCAN_PROXY_URL : 'https://api.anthropic.com/v1/messages';
        var fetchHeaders = { 'Content-Type': 'application/json' };
        if (!SCAN_PROXY_URL || apiKey) {
          // Direct call with developer key (for testing only)
          fetchHeaders['anthropic-version'] = '2023-06-01';
          fetchHeaders['x-api-key'] = apiKey;
          fetchHeaders['anthropic-dangerous-direct-browser-access'] = 'true';
        }
        var response = await fetch(fetchUrl, {
          method: 'POST',
          headers: fetchHeaders,
          body: JSON.stringify({
            model: 'claude-sonnet-4-5',
            max_tokens: 500,
            messages: [{ role: 'user', content: contentBlocks }]
          })
        });

        if (!response.ok) {
          var errData = await response.json().catch(function(){ return {}; });
          throw new Error(errData.error && errData.error.message ? errData.error.message : 'API error ' + response.status);
        }

        var data = await response.json();
        var text = (data.content && data.content[0] && data.content[0].text) ? data.content[0].text : '';
        var clean = text.replace(/```json?/g,'').replace(/```/g,'').trim();
        var parsed;
        try { parsed = JSON.parse(clean); }
        catch(e) { throw new Error('Unexpected response format. Please try again.'); }

        var primaryType = (parsed.primary || '').toLowerCase().replace(/\s/g,'');
        var reasonCode  = (parsed.reason  || '').toLowerCase().replace(/\s/g,'_');

        // Handle all rejection cases  -  use specific reason for targeted message
        if (primaryType === 'unclear' || primaryType === 'unknown' || !hairTypes[primaryType]) {
          var knownReasons = ['multiple_people','hair_styled_or_covered','hair_too_short','hair_wet_or_product','hair_not_visible'];
          showUnclear(knownReasons.indexOf(reasonCode) !== -1 ? reasonCode : 'default');
          return;
        }

        var secondaryType = (parsed.secondary || '').toLowerCase().replace(/\s/g,'');
        if (!hairTypes[secondaryType]) secondaryType = null;

        showResult(primaryType, secondaryType, parsed.description, parsed.confidence, false);

      } catch(err) {
        showError('\u26A0 ' + (err.message || 'Something went wrong. Please try again.'));
      }
    });
  }

})();


/* ============================================================
   SIGNUP GATE  -  Result page
   Demo mode: simulates submission, reveals content.
   Production (Shopify): uses Klaviyo _learnq to subscribe
   the profile and track the quiz completion event, which
   triggers a Klaviyo Flow to send the personalised email +
   FREECOMB welcome gift code (if new subscriber).

   Shopify setup:
   1. Install Klaviyo app \u2192 get your Public API Key
   2. Create a list called "Care Compass" in Klaviyo
   3. Create a Flow triggered by "Completed Care Compass Quiz" metric
      \u2192 Email 1 (0 min delay): Their personalised routine
      \u2192 Split on: Is New Subscriber? \u2192 Email 2: free comb welcome code (FREECOMB)
   4. Paste your Public API Key into KLAVIYO_PUBLIC_KEY below
   ============================================================ */
(function() {

  // \u2500\u2500 CONFIG (set these for live Shopify implementation) \u2500\u2500\u2500\u2500\u2500\u2500
  var KLAVIYO_SIGNUP_PROXY_URL = 'https://lively-valkyrie-6e6aba.netlify.app/.netlify/functions/klaviyo-signup';
  var KLAVIYO_PUBLIC_KEY = 'TGRTLD';     // e.g. 'XyZ123'  -  your Klaviyo Public API Key
  var KLAVIYO_LIST_ID = 'Rxraxr';     // e.g. 'AbCdEf'  -  your "Care Compass" list ID
  var WELCOME_CODE      = 'WELCOME10'; // Shopify discount code for new subscribers
  var IS_DEMO = false;
  // \u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500

  var gateEl       = document.getElementById('cc-gate');
  var gateForm     = document.getElementById('gate-form');
  var gateLoading  = document.getElementById('gate-loading');
  var gateContent  = document.getElementById('gate-content');
  var gateBanner   = document.getElementById('gate-success-banner');
  var gateEmailEl  = document.getElementById('gate-email-confirm');
  var gateDiscMsg  = document.getElementById('gate-discount-msg');

  if (!gateForm) return;

  // ── Visitor country (US = we ship there; everyone else gets the waitlist) ──
  // Shopify's own geolocation endpoint. If it fails or is slow we treat the
  // visitor as US, so a lookup problem never costs a US customer the comb offer.
  var WAITLIST_LIST_ID = 'Vn6kLL'; // "Denmark / Europe waitlist" list in Klaviyo
  var visitorCountry = '';
  var countryReady = fetch('/browsing_context_suggestions.json', { credentials: 'same-origin' })
    .then(function(r) { return r.ok ? r.json() : null; })
    .then(function(j) {
      var c = j && j.detected_values && j.detected_values.country;
      visitorCountry = (c && c.handle) ? String(c.handle).toUpperCase() : '';
      applyCountryMode();
    })
    .catch(function() {});

  function isOutsideShippingArea() {
    return !!visitorCountry && visitorCountry !== 'US';
  }

  function show(id, on) {
    var el = document.getElementById(id);
    if (el) el.style.display = on ? '' : 'none';
  }

  // Swap the gate copy to the waitlist version for visitors outside the US
  function applyCountryMode() {
    var outside = isOutsideShippingArea();
    show('gate-sub-default', !outside);
    show('gate-sub-waitlist', outside);
    show('gate-privacy-default', !outside);
    show('gate-privacy-waitlist', outside);
    // SMS is US/Canada only, so the phone field is hidden for everyone else
    show('gate-phone-field', !outside);
    if (outside) {
      var phoneInput = gateForm.querySelector('#gate-phone');
      if (phoneInput) phoneInput.value = '';
    }
  }

  // Waitlist signup straight from the browser (Klaviyo client API, public key)
  function subscribeToWaitlist(email, firstName) {
    return fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + KLAVIYO_PUBLIC_KEY, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' },
      body: JSON.stringify({
        data: {
          type: 'subscription',
          attributes: {
            custom_source: 'Care Compass Quiz (waitlist)',
            profile: {
              data: {
                type: 'profile',
                // Name and country reach the profile via the quiz proxy call.
                // The client API sets email consent from the list itself and
                // rejects a 'subscriptions' field, so only the email is sent.
                attributes: {
                  email: email
                }
              }
            }
          },
          relationships: { list: { data: { type: 'list', id: WAITLIST_LIST_ID } } }
        }
      })
    }).catch(function(err) { console.warn('Waitlist signup error:', err); });
  }

  gateForm.addEventListener('submit', async function(e) {
    e.preventDefault();

    var nameVal  = (gateForm.querySelector('#gate-name')  || {}).value || '';
    var emailVal = (gateForm.querySelector('#gate-email') || {}).value || '';
    var phoneVal = (gateForm.querySelector('#gate-phone') || {}).value || '';

    // Basic validation
    if (!nameVal.trim() || !emailVal.trim()) {
      gateForm.querySelector('#gate-name').style.borderColor  = nameVal.trim()  ? '' : '#C0614B';
      gateForm.querySelector('#gate-email').style.borderColor = emailVal.trim() ? '' : '#C0614B';
      return;
    }

    // Show loading, hide form
    gateForm.style.display = 'none';
    gateLoading.style.display = 'block';

    // Default new subscriber = true (updated by proxy response below)
    var isNewSubscriber = true;

    // Make sure the country lookup has had its chance (max 1.5s), then decide
    await Promise.race([countryReady, new Promise(function(r) { setTimeout(r, 1500); })]);
    var outsideUS = isOutsideShippingArea();
    if (outsideUS) phoneVal = '';

    // Hair type  -  read from quiz state (set by secondary-type selection IIFE above)
    var _qs        = window.quizState || {};
    var _pType     = _qs.primaryType || '';
    var _family    = {'1':'straight','2':'wavy','3':'curly','4':'coily'}[_pType.charAt(0)] || '';
    var hairType   = _pType ? 'type ' + _pType.toLowerCase() + ', ' + _family : 'unknown';

    // \u2500\u2500 Klaviyo integration (runs in production when keys are set) \u2500\u2500
    if (KLAVIYO_PUBLIC_KEY && KLAVIYO_LIST_ID) {
      try {
        // Subscribe to list via Klaviyo client API (browser-safe, uses public key)
        // Subscription + event tracking now go through our own server proxy
        // (see below) so it also works in private browsing / with ad-blockers.

        // Track quiz completion event \u2192 triggers Klaviyo Flow
        // Build rich event properties so email templates can use {{ event.hair_type }} etc.
        var _cdnBase = 'https://cdn.shopify.com/s/files/1/0621/4077/6527/files/hairtype-';
        var _eventProps = {
          'hair_type':           _pType,
          'hair_family':         _family,
          'hair_title':          _qs.hairTitle      || hairType,
          'secondary_type':      _qs.secondaryType  || '',
          'thickness':           _qs.thickness      || '',
          'routine_title':       _qs.routineTitle   || '',
          'hair_type_image_url': _pType ? _cdnBase + _pType + '-wide.jpg' : '',
          'source':              'Care Compass Quiz',
          // Lets the Klaviyo flow keep the comb offer to visitors we can ship to
          'visitor_country':     visitorCountry || 'unknown',
          'outside_shipping_area': outsideUS
        };
        // Attach up to 5 routine steps as individual properties: routine_step_1, routine_step_2, ...
        (_qs.routineSteps || []).slice(0, 5).forEach(function(step, i) {
          _eventProps['routine_step_' + (i + 1)] = step;
        });

        // Granular properties matching the Klaviyo email template placeholders
        var _rd = _qs.resultFull || {};
        var _imgMap = {
          'Strength Revival Shampoo':    'https://cdn.shopify.com/s/files/1/0621/4077/6527/files/2048x2048px_shampoo_sep25.jpg?v=1758133805',
          'Strength Velvet Conditioner': 'https://cdn.shopify.com/s/files/1/0621/4077/6527/files/2048x2048px_conditioner_sep25.jpg?v=1758133823',
          'Strength Form Gel':           'https://cdn.shopify.com/s/files/1/0621/4077/6527/files/2048x2048px_gel_sep25.jpg?v=1758133836',
          'Pure Form Gel':               'https://cdn.shopify.com/s/files/1/0621/4077/6527/files/2048x2048px_gel_sep25.jpg?v=1758133836'
        };
        var _urlMap = {
          'Strength Revival Shampoo':    'https://www.renraa.com/products/strength-revival-shampoo',
          'Strength Velvet Conditioner': 'https://www.renraa.com/products/strength-velvet-conditioner',
          'Strength Form Gel':           'https://www.renraa.com/products/strength-form-gel',
          'Pure Form Gel':               'https://www.renraa.com/products/strength-form-gel'
        };
        (_rd.steps || []).slice(0, 3).forEach(function(s, i) {
          _eventProps['step_' + (i + 1) + '_product'] = s.product || '';
          _eventProps['step_' + (i + 1) + '_freq']    = s.freq    || '';
          _eventProps['step_' + (i + 1) + '_body']    = s.body    || '';
          _eventProps['step_' + (i + 1) + '_tip']     = s.tip     || '';
        });
        _eventProps['products_title'] = _rd.productsTitle || '';
        (_rd.products || []).slice(0, 3).forEach(function(p, i) {
          _eventProps['product_' + (i + 1) + '_tag']  = p.tag  || '';
          _eventProps['product_' + (i + 1) + '_name'] = p.name || '';
          _eventProps['product_' + (i + 1) + '_desc'] = p.desc || '';
          _eventProps['product_' + (i + 1) + '_fit']  = p.fit  || '';
          _eventProps['product_' + (i + 1) + '_url']  = _urlMap[p.name] || 'https://www.renraa.com/collections/all';
          _eventProps['product_' + (i + 1) + '_image_url'] = _imgMap[p.name] || '';
          // The live Klaviyo builder emails still read the old key, so send both
          _eventProps['product_' + (i + 1) + '_image']     = _imgMap[p.name] || '';
        });
        _eventProps['tips_label'] = _rd.tipsLabel || '';
        _eventProps['tips_title'] = _rd.tipsTitle || '';
        (_rd.tips || []).slice(0, 4).forEach(function(t, i) {
          _eventProps['tip_' + (i + 1) + '_bold'] = t.bold || '';
          _eventProps['tip_' + (i + 1) + '_body'] = t.body || '';
        });

        // The underlayer note was removed from the on-site result page, so the
        // email must not show it either. The live Klaviyo emails show their
        // underlayer section whenever secondary_type is non-empty, so these are
        // always sent empty. The scan's second type is kept as closest_second_type.
        _eventProps['closest_second_type'] = _qs.secondaryType || '';
        _eventProps['secondary_type']      = '';
        _eventProps['secondary_title']     = '';
        _eventProps['secondary_desc']      = '';
        _eventProps['secondary_image_url'] = '';

        // Personalisation callouts — resolved text so the email template can render them directly
        var _pd = window.ccPersonalisation || {};
        var _struggleData = _pd.struggle || {};
        var _colorNoteData = _pd.color || {};
        var _porosityTipsData = _pd.porosity || {};

        var _struggle = _qs.struggle || '';
        var _sd = (_struggle && _struggleData[_struggle]) ? _struggleData[_struggle] : null;
        _eventProps['struggle']           = _struggle;
        _eventProps['struggle_intro']     = _sd ? _sd.intro   : '';
        _eventProps['struggle_tip_bold']  = _sd ? _sd.tipBold : '';
        _eventProps['struggle_tip_body']  = _sd ? _sd.tipBody : '';

        var _colorTreatment = _qs.colorTreatment || '';
        _eventProps['color_treatment'] = _colorTreatment;
        _eventProps['color_note']      = (_colorTreatment && _colorNoteData[_colorTreatment]) ? _colorNoteData[_colorTreatment] : '';

        var _porosity = _qs.porosity || '';
        var _pt = (_porosity && _porosityTipsData[_porosity]) ? _porosityTipsData[_porosity] : null;
        _eventProps['porosity']       = _porosity;
        _eventProps['porosity_bold']  = _pt ? _pt.bold : '';
        _eventProps['porosity_body']  = _pt ? _pt.body : '';

        // Honest note (4a / 4b / 4c only — null for all other types)
        _eventProps['honest_note'] = _rd.honestNote || '';

        // Send everything through our server-side proxy -> Klaviyo
        var _proxyResp = await fetch(KLAVIYO_SIGNUP_PROXY_URL, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            email: emailVal.trim(),
            first_name: nameVal.trim(),
            phone_number: phoneVal.trim() || null,
            // SMS consent only counts if the consent wording was actually on the form
            sms_consent: !!(phoneVal.trim() && document.getElementById('gate-sms-consent')),
            properties: {
              care_compass_hair_type:       hairType,
              care_compass_hair_family:     _family,
              care_compass_struggle:        _qs.struggle        || '',
              care_compass_color_treatment: _qs.colorTreatment  || '',
              care_compass_source:          'quiz',
              care_compass_method:          _qs.fromScan ? 'ai_scan' : 'browse',
              care_compass_porosity:        _qs.porosity        || '',
              care_compass_country:         visitorCountry      || 'unknown'
            },
            event_properties: _eventProps
          })
        });
        // Read is_new from proxy response (proxy should return { is_new: true/false })
        var _proxyData = {};
        try { _proxyData = await _proxyResp.clone().json(); } catch(e) {}
        isNewSubscriber = (_proxyData.is_new !== false); // default true if proxy doesn't return it
        if (!_proxyResp.ok) { console.warn('Care Compass signup failed:', _proxyResp.status); }

        // Outside the US: also put them on the waitlist list
        if (outsideUS) await subscribeToWaitlist(emailVal.trim(), nameVal.trim());

      } catch(err) {
        // Fail silently  -  still reveal the content
        console.warn('Klaviyo subscription error:', err);
      }
    }

    // Fire Meta Pixel Lead event on successful gate submission
    if (typeof fbq === 'function') {
      fbq('track', 'Lead', { content_name: 'Care Compass Quiz', content_category: 'Hair Quiz' });
    }

    // GA4: fire quiz_complete
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: 'quiz_complete', quiz_name: 'Care Compass' });

    // Simulate network delay in demo mode
    var delay = IS_DEMO ? 1400 : 400;
    await new Promise(function(r) { setTimeout(r, delay); });

    // \u2500\u2500 Reveal result \u2500\u2500
    gateCompleted = true;
    gateEl.style.display = 'none';
    gateLoading.style.display = 'none';
    gateBanner.style.display = 'block';
    gateContent.style.display = 'block';
    // Always re-populate the routine at unlock time (guards against hashchange timing issues)
    if (window.updateResultPage) window.updateResultPage();

    // Populate success banner
    if (gateEmailEl) gateEmailEl.textContent = emailVal.trim();

    // Show discount code only for new subscribers we can ship to
    var showComb = isNewSubscriber && !outsideUS;
    if (gateDiscMsg) gateDiscMsg.style.display = showComb ? 'block' : 'none';
    show('gate-waitlist-msg', outsideUS);
    show('cc-cta-body', !outsideUS);
    show('cc-cta-body-waitlist', outsideUS);

    // Update shop button: new US subscribers get the comb code applied, everyone else a plain link
    var shopBtn = document.getElementById('cc-shop-btn');
    if (shopBtn) {
      shopBtn.href = showComb
        ? '/discount/FREECOMB?redirect=/collections/frontpage'
        : 'https://www.renraa.com/collections/frontpage';
      if (outsideUS) shopBtn.innerHTML = 'Explore Ren Raa &#x2192;';
    }

    // Scroll to revealed content
    // Stop the scroll just below whatever is pinned to the top of the window.
    // The announcement bar is always pinned. The theme header is only shown
    // while scrolling UP (it slides away when scrolling down), so which offset
    // is right depends on the direction this scroll will go.
    setTimeout(function() {
      if (!gateBanner) return;
      var headerSec  = document.querySelector('.section-header');
      var stickyEl   = document.querySelector('sticky-header');
      var headerPos  = headerSec ? window.getComputedStyle(headerSec).position : '';
      var headerPins = headerPos === 'sticky' || headerPos === 'fixed';
      var headerH    = headerPins ? headerSec.offsetHeight : 0;
      var hidesOnScrollDown = !!(stickyEl && stickyEl.getAttribute('data-sticky-type') === 'on-scroll-up');

      // Everything else pinned to the top (announcement bar etc.)
      var otherPinned = 0;
      var els = document.querySelectorAll('body *');
      for (var i = 0; i < els.length; i++) {
        if (headerSec && headerSec.contains(els[i])) continue;
        var pos = window.getComputedStyle(els[i]).position;
        if (pos !== 'sticky' && pos !== 'fixed') continue;
        var r = els[i].getBoundingClientRect();
        if (r.height > 0 && r.width >= window.innerWidth * 0.8 && r.top >= -1 && r.top < 10 &&
            r.bottom <= window.innerHeight * 0.4 && r.bottom > otherPinned) {
          otherPinned = r.bottom;
        }
      }

      var bannerTop = gateBanner.getBoundingClientRect().top + window.pageYOffset;
      var withHeader = bannerTop - otherPinned - headerH;
      var goingUp = withHeader < window.pageYOffset;
      var top = (goingUp || !hidesOnScrollDown) ? withHeader : bannerTop - otherPinned;
      window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
    }, 100);
  });
  // Track whether gate has already been completed this session
  var gateCompleted = false;

  // When user arrives at page-4, show gate (unless already completed this session)
  window.addEventListener('hashchange', function() {
    if (window.location.hash === '#page-4' && !gateCompleted) {
      // Ensure gate is visible and content is hidden
      if (gateForm)    { gateForm.style.display = ''; }
      if (gateLoading) gateLoading.style.display = 'none';
      if (gateEl)      gateEl.style.display      = '';
      if (gateBanner)  gateBanner.style.display   = 'none';
      if (gateContent) gateContent.style.display  = 'none';
    }
  });

  // Mark completed so navigating away and back doesn't re-lock result
  gateForm && gateForm.addEventListener('submit', function() {
    gateCompleted = true;
  }, { once: false }); // handled in submit handler above; this just sets flag

})();

// ── Discount code copy ──────────────────────────────────────────────────────
window.ccCopyCode = function(btn) {
  var codeEl = document.getElementById('cc-discount-code-text');
  var code = codeEl ? codeEl.textContent.trim() : 'FREECOMB';
  function _markCopied() {
    btn.classList.add('is-copied');
    setTimeout(function() { btn.classList.remove('is-copied'); }, 2000);
  }
  function _fallbackCopy(text) {
    var ta = document.createElement('textarea');
    ta.value = text;
    ta.style.cssText = 'position:fixed;top:-9999px;left:-9999px;opacity:0;';
    document.body.appendChild(ta);
    ta.select();
    try { document.execCommand('copy'); } catch(e) {}
    document.body.removeChild(ta);
  }
  if (navigator.clipboard && navigator.clipboard.writeText) {
    navigator.clipboard.writeText(code).then(_markCopied).catch(function() {
      _fallbackCopy(code); _markCopied();
    });
  } else {
    _fallbackCopy(code); _markCopied();
  }
};
